"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groups = void 0;
const GroupId_1 = require("./GroupId");
const Fields_1 = require("./Fields");
const groups = (payload) => [
    {
        id: GroupId_1.GroupId.AdditionalData,
        description: 'This group will be used by the UI when underwriting identifies that additional data must be collected.',
        labelTitle: 'group.title.additional_data',
        fallbackTitle: 'Additional information',
        labelSubtitle: 'group.subtitle.additional_data',
        fallbackSubtitle: 'We are reviewing your application and need some more information to proceed.',
        fields: {},
        fieldPathsOnPayload: {},
        priority: 1,
    },
    {
        id: GroupId_1.GroupId.AdsManagerGetStarted,
        description: 'Ads Manager onboarding getting started page',
        labelTitle: 'group.title.ads_manager_get_started',
        fallbackTitle: 'Almost there.',
        labelSubtitle: 'group.subtitle.ads_manager_get_started',
        fallbackSubtitle: 'Please provide a billing email that campaign invoices will be sent to. You must be an admin user to activate the account. Admin can then grant permissions to other users.',
        fields: {
            billing_email: Fields_1.Fields.billing.billing_email,
        },
        fieldPathsOnPayload: {
            billing_email: 'billing.billing_email',
        },
        priority: 9,
    },
    {
        id: GroupId_1.GroupId.AdultServices31,
        description: '',
        labelTitle: 'group.title.adult_services_31',
        fallbackTitle: 'Adult services',
        labelSubtitle: 'group.subtitle.adult_services_31',
        fallbackSubtitle: '',
        fields: {
            adult_service_percentage_merchants: Fields_1.Fields.mor_group_answers.adult_service_percentage_merchants,
            adult_service_risk_handling_description: Fields_1.Fields.mor_group_answers.adult_service_risk_handling_description,
            adult_service_transaction_volume: Fields_1.Fields.mor_group_answers.adult_service_transaction_volume,
            adult_service_year_of_experience: Fields_1.Fields.mor_group_answers.adult_service_year_of_experience,
        },
        fieldPathsOnPayload: {
            adult_service_percentage_merchants: 'mor_group_answers.adult_service_percentage_merchants',
            adult_service_risk_handling_description: 'mor_group_answers.adult_service_risk_handling_description',
            adult_service_transaction_volume: 'mor_group_answers.adult_service_transaction_volume',
            adult_service_year_of_experience: 'mor_group_answers.adult_service_year_of_experience',
        },
        priority: 31,
    },
    {
        id: GroupId_1.GroupId.AdultServices32,
        description: '',
        labelTitle: 'group.title.adult_services_32',
        fallbackTitle: 'Adult services',
        labelSubtitle: 'group.subtitle.adult_services_32',
        fallbackSubtitle: '',
        fields: {
            adult_service_operation_not_allowed_description: Fields_1.Fields.mor_group_answers.adult_service_operation_not_allowed_description,
            adult_service_permission_description: Fields_1.Fields.mor_group_answers.adult_service_permission_description,
        },
        fieldPathsOnPayload: {
            adult_service_operation_not_allowed_description: 'mor_group_answers.adult_service_operation_not_allowed_description',
            adult_service_permission_description: 'mor_group_answers.adult_service_permission_description',
        },
        priority: 32,
    },
    {
        id: GroupId_1.GroupId.AdultServices33,
        description: '',
        labelTitle: 'group.title.adult_services_33',
        fallbackTitle: 'Adult services',
        labelSubtitle: 'group.subtitle.adult_services_33',
        fallbackSubtitle: '',
        fields: {
            adult_service_due_diligence_key_criteria: Fields_1.Fields.mor_group_answers.adult_service_due_diligence_key_criteria,
            adult_service_due_diligence_key_criteria_other_description: Fields_1.Fields.mor_group_answers.adult_service_due_diligence_key_criteria_other_description,
        },
        fieldPathsOnPayload: {
            adult_service_due_diligence_key_criteria: 'mor_group_answers.adult_service_due_diligence_key_criteria',
            adult_service_due_diligence_key_criteria_other_description: 'mor_group_answers.adult_service_due_diligence_key_criteria_other_description',
        },
        priority: 33,
    },
    {
        id: GroupId_1.GroupId.AdultServices34,
        description: '',
        labelTitle: 'group.title.adult_services_34',
        fallbackTitle: 'Adult services',
        labelSubtitle: 'group.subtitle.adult_services_34',
        fallbackSubtitle: '',
        fields: {
            adult_service_compliance_control: Fields_1.Fields.mor_group_answers.adult_service_compliance_control,
        },
        fieldPathsOnPayload: {
            adult_service_compliance_control: 'mor_group_answers.adult_service_compliance_control',
        },
        priority: 34,
    },
    {
        id: GroupId_1.GroupId.AdultServices35,
        description: '',
        labelTitle: 'group.title.adult_services_35',
        fallbackTitle: 'Adult services',
        labelSubtitle: 'group.subtitle.adult_services_35',
        fallbackSubtitle: '',
        fields: {
            adult_service_legality_assessment_description: Fields_1.Fields.mor_group_answers.adult_service_legality_assessment_description,
        },
        fieldPathsOnPayload: {
            adult_service_legality_assessment_description: 'mor_group_answers.adult_service_legality_assessment_description',
        },
        priority: 35,
    },
    {
        id: GroupId_1.GroupId.AdultServices36,
        description: '',
        labelTitle: 'group.title.adult_services_36',
        fallbackTitle: 'Adult services',
        labelSubtitle: 'group.subtitle.adult_services_36',
        fallbackSubtitle: '',
        fields: {
            adult_service_company_conduct: Fields_1.Fields.mor_group_answers.adult_service_company_conduct,
        },
        fieldPathsOnPayload: {
            adult_service_company_conduct: 'mor_group_answers.adult_service_company_conduct',
        },
        priority: 36,
    },
    {
        id: GroupId_1.GroupId.AdultServices37,
        description: '',
        labelTitle: 'group.title.adult_services_37',
        fallbackTitle: 'Adult services',
        labelSubtitle: 'group.subtitle.adult_services_37',
        fallbackSubtitle: '',
        fields: {
            adult_service_applicable_measures: Fields_1.Fields.mor_group_answers.adult_service_applicable_measures,
            adult_service_applicable_measures_other_description: Fields_1.Fields.mor_group_answers.adult_service_applicable_measures_other_description,
        },
        fieldPathsOnPayload: {
            adult_service_applicable_measures: 'mor_group_answers.adult_service_applicable_measures',
            adult_service_applicable_measures_other_description: 'mor_group_answers.adult_service_applicable_measures_other_description',
        },
        priority: 37,
    },
    {
        id: GroupId_1.GroupId.AdultServices38,
        description: '',
        labelTitle: 'group.title.adult_services_38',
        fallbackTitle: 'Adult services',
        labelSubtitle: 'group.subtitle.adult_services_38',
        fallbackSubtitle: '',
        fields: {
            adult_service_procedure_for_disputes_description: Fields_1.Fields.mor_group_answers.adult_service_procedure_for_disputes_description,
        },
        fieldPathsOnPayload: {
            adult_service_procedure_for_disputes_description: 'mor_group_answers.adult_service_procedure_for_disputes_description',
        },
        priority: 38,
    },
    {
        id: GroupId_1.GroupId.AdultServices39,
        description: '',
        labelTitle: 'group.title.adult_services_39',
        fallbackTitle: 'Adult services',
        labelSubtitle: 'group.subtitle.adult_services_39',
        fallbackSubtitle: '',
        fields: {
            adult_service_high_risk_description: Fields_1.Fields.mor_group_answers.adult_service_high_risk_description,
            adult_service_is_high_risk: Fields_1.Fields.mor_group_answers.adult_service_is_high_risk,
        },
        fieldPathsOnPayload: {
            adult_service_high_risk_description: 'mor_group_answers.adult_service_high_risk_description',
            adult_service_is_high_risk: 'mor_group_answers.adult_service_is_high_risk',
        },
        priority: 39,
    },
    {
        id: GroupId_1.GroupId.BankAccount,
        description: 'Bank account details.',
        labelTitle: 'group.title.bank_account',
        fallbackTitle: 'What are your bank account details?',
        labelSubtitle: 'group.subtitle.bank_account',
        fallbackSubtitle: 'Klarna transactions will be transferred to this bank account.',
        fields: {
            bank_accounts: Fields_1.Fields.bank_accounts,
        },
        fieldPathsOnPayload: {
            bank_accounts: 'bank_accounts',
        },
        priority: 110,
    },
    {
        id: GroupId_1.GroupId.BillingBusinessPartner,
        description: 'Business Partner details.',
        labelTitle: 'group.title.billing_business_partner',
        fallbackTitle: 'What are your business partner details?',
        labelSubtitle: 'group.subtitle.billing_business_partner',
        fallbackSubtitle: 'Business Partner details needed for automated billing.',
        fields: {
            invoice_recipients: Fields_1.Fields.billing.invoice_recipients,
            company_name: Fields_1.Fields.business_information.company_name,
            is_registered: Fields_1.Fields.business_information.is_registered,
            registered_address: Fields_1.Fields.business_information.registered_address,
            registration_country: Fields_1.Fields.business_information.registration_country,
            registration_id: Fields_1.Fields.business_information.registration_id,
            subject_to_vat: Fields_1.Fields.business_information.subject_to_vat,
            vat_id: Fields_1.Fields.business_information.vat_id,
        },
        fieldPathsOnPayload: {
            invoice_recipients: 'billing.invoice_recipients',
            company_name: 'business_information.company_name',
            is_registered: 'business_information.is_registered',
            registered_address: 'business_information.registered_address',
            registration_country: 'business_information.registration_country',
            registration_id: 'business_information.registration_id',
            subject_to_vat: 'business_information.subject_to_vat',
            vat_id: 'business_information.vat_id',
        },
        priority: 11,
    },
    {
        id: GroupId_1.GroupId.BusinessInformationGroup,
        description: 'If you plan to become Klarna\'s Merchant of Record and intend to contract multiple entities within your group, you can complete the questionnaire from a group-level perspective, provided that all entities adhere to the same standards or logic. Please fill out this questionnaire accordingly. If there are any differences between the contracting entities, such as those arising from local laws, kindly include this information in your response. If only one legal entity intends to become  Klarna\'s Merchant of Record and it will solely sign an agreement, please complete the questionnaire specifically for that contracting entity. Definition: A \'group of entities\' refers to a collection of companies or organizations that are related through common ownership, control, or management. This typically involves a parent company and its subsidiaries, affiliates, or other related companies. These entities may operate in various locations or industries but are connected through their organizational structure and governance and usually operate under the same brand.',
        labelTitle: 'group.title.business_information_group',
        fallbackTitle: 'Group onboarding',
        labelSubtitle: 'group.subtitle.business_information_group',
        fallbackSubtitle: 'What are your entity details on group level for becoming Klarna\'s Acquiring Partner?',
        fields: {
            business_information_group: Fields_1.Fields.mor_group_answers.business_information_group,
        },
        fieldPathsOnPayload: {
            business_information_group: 'mor_group_answers.business_information_group',
        },
        priority: 1,
    },
    {
        id: GroupId_1.GroupId.BusinessSize,
        description: 'Business size',
        labelTitle: 'group.title.business_size',
        fallbackTitle: 'What is your yearly revenue?',
        labelSubtitle: 'group.subtitle.business_size',
        fallbackSubtitle: 'We need some basic information regarding your business to process your application.',
        fields: {
            business_size: Fields_1.Fields.business_size,
        },
        fieldPathsOnPayload: {
            business_size: 'business_size',
        },
        priority: 40,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk1,
        description: 'This questionnaire is primarily designed for an operational company entering a Merchant of Record (MoR) relationship with Klarna. Each operational company signing a contract with Klarna is treated as an independent entity for Counterparty Risk assessment. In some cases, a group may opt to have one of its stronger entities or its parent company act as a guarantor for its operational companies such as when operational companies are newly established in certain markets and lack the credit history needed to secure favorable or unified payment terms. If your group fits this scenario, select \'No\' provide the guarantor\'s information in the next question, and complete the Counterparty Risk Questionnaire onward from an aggregated perspective (including all markets or deals covered by the guarantor). If the designated entity is liable for itself, select \'Yes\' and complete the rest of the Counterparty Risk Questionnaire accordingly. If you have any questions, feel free to contact your Klarna representative. Our Risk Team will be happy to assist. If no, please provide the information of the entity that will sign the contract and legally liable for this collaboration with Klarna',
        labelTitle: 'group.title.counterparty_risk_1',
        fallbackTitle: 'Counterparty Risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_1',
        fallbackSubtitle: '',
        fields: {
            is_signing: Fields_1.Fields.mor_entity_answers.is_signing,
            signing_country: Fields_1.Fields.mor_entity_answers.signing_country,
            signing_legal_entity_name: Fields_1.Fields.mor_entity_answers.signing_legal_entity_name,
            signing_legal_entity_registration_id: Fields_1.Fields.mor_entity_answers.signing_legal_entity_registration_id,
        },
        fieldPathsOnPayload: {
            is_signing: 'mor_entity_answers.is_signing',
            signing_country: 'mor_entity_answers.signing_country',
            signing_legal_entity_name: 'mor_entity_answers.signing_legal_entity_name',
            signing_legal_entity_registration_id: 'mor_entity_answers.signing_legal_entity_registration_id',
        },
        priority: 15,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk10,
        description: 'Note that the merchants are expected to own the goods/claim, have their own customer care, and be liable to buyers, especially for marketplace and vouchers. Travel - E.g. Air, Bus, Train, Ferry/Boat, Car Rental, Hotel, Resort, etc. Event Tickets - E.g. Concert, Festival, Recreational experience, etc. Subscription of physical goods - e.g. Magazine, Dietary supplements, etc. Marketplaces* Vouchers* Online Memberships - E.g. Dating Apps, Communities, Streaming, etc. Digital Goods - E.g. Gaming, Software, Other downloads, etc.',
        labelTitle: 'group.title.counterparty_risk_10',
        fallbackTitle: 'Counterparty Risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_10',
        fallbackSubtitle: '',
        fields: {
            is_operating_in_high_risk_segments: Fields_1.Fields.mor_entity_answers.is_operating_in_high_risk_segments,
        },
        fieldPathsOnPayload: {
            is_operating_in_high_risk_segments: 'mor_entity_answers.is_operating_in_high_risk_segments',
        },
        priority: 25,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk11,
        description: 'Supplementary Partner Data refers to additional order line details for certain segments that are essential for Klarna\'s risk management and monitoring activities. Should you have any queries or require clarification regarding this requirement, please contact your Klarna representative. Required Segments: Travel - E.g. Air, Bus, Train, Ferry/Boat, Car Rental, Hotel, Resort, etc. Event Tickets - E.g. Concert, Festival, Recreational experience, etc. Subscription of physical goods - E.g. Magazine, Dietary supplements, etc. Marketplaces; Vouchers; Online Memberships - E.g. Dating Apps, Communities, Streaming, etc. Digital Goods - E.g. Gaming, Software, Other downloads, etc.',
        labelTitle: 'group.title.counterparty_risk_11',
        fallbackTitle: 'Counterparty Risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_11',
        fallbackSubtitle: '',
        fields: {
            has_supplementary_partner_data: Fields_1.Fields.mor_entity_answers.has_supplementary_partner_data,
            no_supplementary_partner_data_description: Fields_1.Fields.mor_entity_answers.no_supplementary_partner_data_description,
        },
        fieldPathsOnPayload: {
            has_supplementary_partner_data: 'mor_entity_answers.has_supplementary_partner_data',
            no_supplementary_partner_data_description: 'mor_entity_answers.no_supplementary_partner_data_description',
        },
        priority: 26,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk12,
        description: '',
        labelTitle: 'group.title.counterparty_risk_12',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_12',
        fallbackSubtitle: 'Fill in 0 if there is no plan to onboard such a business category.',
        fields: {
            travel_segment_percentage: Fields_1.Fields.mor_entity_answers.travel_segment_percentage,
        },
        fieldPathsOnPayload: {
            travel_segment_percentage: 'mor_entity_answers.travel_segment_percentage',
        },
        priority: 27,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk13,
        description: '',
        labelTitle: 'group.title.counterparty_risk_13',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_13',
        fallbackSubtitle: 'Fill in 0 if there is no plan to onboard such a business category',
        fields: {
            event_organizer_segment_percentage: Fields_1.Fields.mor_entity_answers.event_organizer_segment_percentage,
        },
        fieldPathsOnPayload: {
            event_organizer_segment_percentage: 'mor_entity_answers.event_organizer_segment_percentage',
        },
        priority: 28,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk14,
        description: '',
        labelTitle: 'group.title.counterparty_risk_14',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_14',
        fallbackSubtitle: 'Fill in 0 if there is no plan to onboard such a business category',
        fields: {
            air_line_segment_percentage: Fields_1.Fields.mor_entity_answers.air_line_segment_percentage,
        },
        fieldPathsOnPayload: {
            air_line_segment_percentage: 'mor_entity_answers.air_line_segment_percentage',
        },
        priority: 29,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk15,
        description: '',
        labelTitle: 'group.title.counterparty_risk_15',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_15',
        fallbackSubtitle: 'Fill in 0 if there is no plan to onboard such a business category',
        fields: {
            accommodation_segment_percentage: Fields_1.Fields.mor_entity_answers.accommodation_segment_percentage,
        },
        fieldPathsOnPayload: {
            accommodation_segment_percentage: 'mor_entity_answers.accommodation_segment_percentage',
        },
        priority: 30,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk16,
        description: '',
        labelTitle: 'group.title.counterparty_risk_16',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_16',
        fallbackSubtitle: 'Please briefly explain and specify its volume split of your total portfolio if you intend to offer Klarna\'s payment services to any other types of travel business that were not previously covered. Fill in 0 if there is no plan to onboard any other types of travel business',
        fields: {
            other_travel_business_percentage: Fields_1.Fields.mor_entity_answers.other_travel_business_percentage,
            other_travel_business_percentage_description: Fields_1.Fields.mor_entity_answers.other_travel_business_percentage_description,
        },
        fieldPathsOnPayload: {
            other_travel_business_percentage: 'mor_entity_answers.other_travel_business_percentage',
            other_travel_business_percentage_description: 'mor_entity_answers.other_travel_business_percentage_description',
        },
        priority: 31,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk17,
        description: '',
        labelTitle: 'group.title.counterparty_risk_17',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_17',
        fallbackSubtitle: '',
        fields: {
            has_risk_rate: Fields_1.Fields.mor_entity_answers.has_risk_rate,
        },
        fieldPathsOnPayload: {
            has_risk_rate: 'mor_entity_answers.has_risk_rate',
        },
        priority: 32,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk18,
        description: '',
        labelTitle: 'group.title.counterparty_risk_18',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_18',
        fallbackSubtitle: 'Please select all that apply',
        fields: {
            credit_assessment_triggered_events: Fields_1.Fields.mor_entity_answers.credit_assessment_triggered_events,
            credit_assessment_triggered_events_details: Fields_1.Fields.mor_entity_answers.credit_assessment_triggered_events_details,
        },
        fieldPathsOnPayload: {
            credit_assessment_triggered_events: 'mor_entity_answers.credit_assessment_triggered_events',
            credit_assessment_triggered_events_details: 'mor_entity_answers.credit_assessment_triggered_events_details',
        },
        priority: 33,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk19,
        description: '',
        labelTitle: 'group.title.counterparty_risk_19',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_19',
        fallbackSubtitle: 'Please select all that apply',
        fields: {
            credit_assessment_frequency_details: Fields_1.Fields.mor_entity_answers.credit_assessment_frequency_details,
            credit_assessment_frequency_guideline: Fields_1.Fields.mor_entity_answers.credit_assessment_frequency_guideline,
        },
        fieldPathsOnPayload: {
            credit_assessment_frequency_details: 'mor_entity_answers.credit_assessment_frequency_details',
            credit_assessment_frequency_guideline: 'mor_entity_answers.credit_assessment_frequency_guideline',
        },
        priority: 34,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk2,
        description: '',
        labelTitle: 'group.title.counterparty_risk_2',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_2',
        fallbackSubtitle: 'What volume do you expect to come from merchants under this specific business entity in the next 12 months?',
        fields: {
            currency: Fields_1.Fields.mor_entity_answers.currency,
            klarna_volume_amount: Fields_1.Fields.mor_entity_answers.klarna_volume_amount,
        },
        fieldPathsOnPayload: {
            currency: 'mor_entity_answers.currency',
            klarna_volume_amount: 'mor_entity_answers.klarna_volume_amount',
        },
        priority: 16,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk20,
        description: '',
        labelTitle: 'group.title.counterparty_risk_20',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_20',
        fallbackSubtitle: '',
        fields: {
            financial_assessment_frequency_details: Fields_1.Fields.mor_entity_answers.financial_assessment_frequency_details,
            financial_assessment_frequency_guideline: Fields_1.Fields.mor_entity_answers.financial_assessment_frequency_guideline,
        },
        fieldPathsOnPayload: {
            financial_assessment_frequency_details: 'mor_entity_answers.financial_assessment_frequency_details',
            financial_assessment_frequency_guideline: 'mor_entity_answers.financial_assessment_frequency_guideline',
        },
        priority: 35,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk21,
        description: '',
        labelTitle: 'group.title.counterparty_risk_21',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_21',
        fallbackSubtitle: 'Please select all that apply',
        fields: {
            financial_analysis_aspects: Fields_1.Fields.mor_entity_answers.financial_analysis_aspects,
        },
        fieldPathsOnPayload: {
            financial_analysis_aspects: 'mor_entity_answers.financial_analysis_aspects',
        },
        priority: 36,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk22,
        description: '',
        labelTitle: 'group.title.counterparty_risk_22',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_22',
        fallbackSubtitle: '',
        fields: {
            collateral_requirements_details: Fields_1.Fields.mor_entity_answers.collateral_requirements_details,
            has_collateral_requirements: Fields_1.Fields.mor_entity_answers.has_collateral_requirements,
        },
        fieldPathsOnPayload: {
            collateral_requirements_details: 'mor_entity_answers.collateral_requirements_details',
            has_collateral_requirements: 'mor_entity_answers.has_collateral_requirements',
        },
        priority: 37,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk23,
        description: '',
        labelTitle: 'group.title.counterparty_risk_23',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_23',
        fallbackSubtitle: '',
        fields: {
            has_adjusting_trading_terms: Fields_1.Fields.mor_entity_answers.has_adjusting_trading_terms,
        },
        fieldPathsOnPayload: {
            has_adjusting_trading_terms: 'mor_entity_answers.has_adjusting_trading_terms',
        },
        priority: 38,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk24,
        description: '',
        labelTitle: 'group.title.counterparty_risk_24',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_24',
        fallbackSubtitle: '',
        fields: {
            adjusting_credit_terms_details: Fields_1.Fields.mor_entity_answers.adjusting_credit_terms_details,
            has_adjusting_credit_terms: Fields_1.Fields.mor_entity_answers.has_adjusting_credit_terms,
        },
        fieldPathsOnPayload: {
            adjusting_credit_terms_details: 'mor_entity_answers.adjusting_credit_terms_details',
            has_adjusting_credit_terms: 'mor_entity_answers.has_adjusting_credit_terms',
        },
        priority: 39,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk25,
        description: '',
        labelTitle: 'group.title.counterparty_risk_25',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_25',
        fallbackSubtitle: '',
        fields: {
            credit_risk_assessment_report_details: Fields_1.Fields.mor_entity_answers.credit_risk_assessment_report_details,
            credit_risk_assessment_report_frequency: Fields_1.Fields.mor_entity_answers.credit_risk_assessment_report_frequency,
        },
        fieldPathsOnPayload: {
            credit_risk_assessment_report_details: 'mor_entity_answers.credit_risk_assessment_report_details',
            credit_risk_assessment_report_frequency: 'mor_entity_answers.credit_risk_assessment_report_frequency',
        },
        priority: 40,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk3,
        description: 'The average timeframe for fulfilling orders refers to the approximate period from when orders are captured to when they are delivered. An example of an extended fulfillment time: Around 30 days, as our portfolio primarily consists of dropshippers who ship bi-weekly from China to Europe.',
        labelTitle: 'group.title.counterparty_risk_3',
        fallbackTitle: 'Counterparty Risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_3',
        fallbackSubtitle: '',
        fields: {
            average_timeframe_for_fulfilling_order: Fields_1.Fields.mor_entity_answers.average_timeframe_for_fulfilling_order,
            average_timeframe_for_fulfilling_order_reason: Fields_1.Fields.mor_entity_answers.average_timeframe_for_fulfilling_order_reason,
        },
        fieldPathsOnPayload: {
            average_timeframe_for_fulfilling_order: 'mor_entity_answers.average_timeframe_for_fulfilling_order',
            average_timeframe_for_fulfilling_order_reason: 'mor_entity_answers.average_timeframe_for_fulfilling_order_reason',
        },
        priority: 18,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk4,
        description: 'Understanding the flow of funds between you and your merchants helps us assess the efficiency and stability of your liquidity management, which in turn enables us to offer you reasonable payment terms.',
        labelTitle: 'group.title.counterparty_risk_4',
        fallbackTitle: 'Counterparty Risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_4',
        fallbackSubtitle: '',
        fields: {
            average_interval_for_settling_fund: Fields_1.Fields.mor_entity_answers.average_interval_for_settling_fund,
            average_interval_for_settling_fund_reason: Fields_1.Fields.mor_entity_answers.average_interval_for_settling_fund_reason,
        },
        fieldPathsOnPayload: {
            average_interval_for_settling_fund: 'mor_entity_answers.average_interval_for_settling_fund',
            average_interval_for_settling_fund_reason: 'mor_entity_answers.average_interval_for_settling_fund_reason',
        },
        priority: 19,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk5,
        description: 'Please provide relevant internal policy documentation or regulatory requirements to your Klarna representative.',
        labelTitle: 'group.title.counterparty_risk_5',
        fallbackTitle: 'Counterparty Risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_5',
        fallbackSubtitle: '',
        fields: {
            escrow_account: Fields_1.Fields.mor_entity_answers.escrow_account,
            estimated_percentage: Fields_1.Fields.mor_entity_answers.estimated_percentage,
        },
        fieldPathsOnPayload: {
            escrow_account: 'mor_entity_answers.escrow_account',
            estimated_percentage: 'mor_entity_answers.estimated_percentage',
        },
        priority: 20,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk6,
        description: 'If the sales distribution within a particular industry is highly fragmented, please use \'multiple\' or provide a brief explanation. Example: Adult clothing & shoes, 30%, DE & AU; Jewelry and watches, 30%, GB; Miscellaneous household goods, 20%, GB; Gardening and furniture, 10%, Northern EU; Sport and outdoor gear, 5%, multiple; Tickets, train and bus services, 5%, CN',
        labelTitle: 'group.title.counterparty_risk_6',
        fallbackTitle: 'Counterparty Risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_6',
        fallbackSubtitle: 'Please fill in the percentage (%) and region',
        fields: {
            segment_splits: Fields_1.Fields.mor_entity_answers.segment_splits,
        },
        fieldPathsOnPayload: {
            segment_splits: 'mor_entity_answers.segment_splits',
        },
        priority: 21,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk7,
        description: '',
        labelTitle: 'group.title.counterparty_risk_7',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_7',
        fallbackSubtitle: 'Example: Top 1 Company: Germany, Food and Beverage, 20%',
        fields: {
            largest_merchant_info: Fields_1.Fields.mor_entity_answers.largest_merchant_info,
        },
        fieldPathsOnPayload: {
            largest_merchant_info: 'mor_entity_answers.largest_merchant_info',
        },
        priority: 22,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk8,
        description: '',
        labelTitle: 'group.title.counterparty_risk_8',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_8',
        fallbackSubtitle: 'Example: Top 2 Company: China, Clothing and Shoes, 19%',
        fields: {
            second_largest_merchant_info: Fields_1.Fields.mor_entity_answers.second_largest_merchant_info,
        },
        fieldPathsOnPayload: {
            second_largest_merchant_info: 'mor_entity_answers.second_largest_merchant_info',
        },
        priority: 23,
    },
    {
        id: GroupId_1.GroupId.CounterpartyRisk9,
        description: '',
        labelTitle: 'group.title.counterparty_risk_9',
        fallbackTitle: 'Counterparty risk',
        labelSubtitle: 'group.subtitle.counterparty_risk_9',
        fallbackSubtitle: 'Example:  Top 3 Company: UK, Furniture, 12%',
        fields: {
            third_largest_merchant_info: Fields_1.Fields.mor_entity_answers.third_largest_merchant_info,
        },
        fieldPathsOnPayload: {
            third_largest_merchant_info: 'mor_entity_answers.third_largest_merchant_info',
        },
        priority: 24,
    },
    {
        id: GroupId_1.GroupId.Crypto21,
        description: '',
        labelTitle: 'group.title.crypto_21',
        fallbackTitle: 'Cryptocurrency services',
        labelSubtitle: 'group.subtitle.crypto_21',
        fallbackSubtitle: '',
        fields: {
            crypto_percentage_merchants: Fields_1.Fields.mor_group_answers.crypto_percentage_merchants,
            crypto_risk_handling_description: Fields_1.Fields.mor_group_answers.crypto_risk_handling_description,
            crypto_transaction_volume: Fields_1.Fields.mor_group_answers.crypto_transaction_volume,
            crypto_year_of_experience: Fields_1.Fields.mor_group_answers.crypto_year_of_experience,
        },
        fieldPathsOnPayload: {
            crypto_percentage_merchants: 'mor_group_answers.crypto_percentage_merchants',
            crypto_risk_handling_description: 'mor_group_answers.crypto_risk_handling_description',
            crypto_transaction_volume: 'mor_group_answers.crypto_transaction_volume',
            crypto_year_of_experience: 'mor_group_answers.crypto_year_of_experience',
        },
        priority: 21,
    },
    {
        id: GroupId_1.GroupId.Crypto22,
        description: '',
        labelTitle: 'group.title.crypto_22',
        fallbackTitle: 'Cryptocurrency services',
        labelSubtitle: 'group.subtitle.crypto_22',
        fallbackSubtitle: '',
        fields: {
            crypto_operation_not_allowed_description: Fields_1.Fields.mor_group_answers.crypto_operation_not_allowed_description,
            crypto_permission_description: Fields_1.Fields.mor_group_answers.crypto_permission_description,
        },
        fieldPathsOnPayload: {
            crypto_operation_not_allowed_description: 'mor_group_answers.crypto_operation_not_allowed_description',
            crypto_permission_description: 'mor_group_answers.crypto_permission_description',
        },
        priority: 22,
    },
    {
        id: GroupId_1.GroupId.Crypto23,
        description: '',
        labelTitle: 'group.title.crypto_23',
        fallbackTitle: 'Cryptocurrency services',
        labelSubtitle: 'group.subtitle.crypto_23',
        fallbackSubtitle: '',
        fields: {
            crypto_due_diligence_key_criteria: Fields_1.Fields.mor_group_answers.crypto_due_diligence_key_criteria,
            crypto_due_diligence_key_criteria_other_description: Fields_1.Fields.mor_group_answers.crypto_due_diligence_key_criteria_other_description,
        },
        fieldPathsOnPayload: {
            crypto_due_diligence_key_criteria: 'mor_group_answers.crypto_due_diligence_key_criteria',
            crypto_due_diligence_key_criteria_other_description: 'mor_group_answers.crypto_due_diligence_key_criteria_other_description',
        },
        priority: 23,
    },
    {
        id: GroupId_1.GroupId.Crypto24,
        description: '',
        labelTitle: 'group.title.crypto_24',
        fallbackTitle: 'Cryptocurrency services',
        labelSubtitle: 'group.subtitle.crypto_24',
        fallbackSubtitle: '',
        fields: {
            crypto_compliance_control: Fields_1.Fields.mor_group_answers.crypto_compliance_control,
        },
        fieldPathsOnPayload: {
            crypto_compliance_control: 'mor_group_answers.crypto_compliance_control',
        },
        priority: 24,
    },
    {
        id: GroupId_1.GroupId.Crypto25,
        description: '',
        labelTitle: 'group.title.crypto_25',
        fallbackTitle: 'Cryptocurrency services',
        labelSubtitle: 'group.subtitle.crypto_25',
        fallbackSubtitle: '',
        fields: {
            crypto_company_conduct: Fields_1.Fields.mor_group_answers.crypto_company_conduct,
        },
        fieldPathsOnPayload: {
            crypto_company_conduct: 'mor_group_answers.crypto_company_conduct',
        },
        priority: 25,
    },
    {
        id: GroupId_1.GroupId.Crypto26,
        description: '',
        labelTitle: 'group.title.crypto_26',
        fallbackTitle: 'Cryptocurrency services',
        labelSubtitle: 'group.subtitle.crypto_26',
        fallbackSubtitle: '',
        fields: {
            crypto_applicable_measures: Fields_1.Fields.mor_group_answers.crypto_applicable_measures,
            crypto_applicable_measures_other_description: Fields_1.Fields.mor_group_answers.crypto_applicable_measures_other_description,
        },
        fieldPathsOnPayload: {
            crypto_applicable_measures: 'mor_group_answers.crypto_applicable_measures',
            crypto_applicable_measures_other_description: 'mor_group_answers.crypto_applicable_measures_other_description',
        },
        priority: 26,
    },
    {
        id: GroupId_1.GroupId.Crypto27,
        description: '',
        labelTitle: 'group.title.crypto_27',
        fallbackTitle: 'Cryptocurrency services',
        labelSubtitle: 'group.subtitle.crypto_27',
        fallbackSubtitle: '',
        fields: {
            crypto_procedure_for_disputes_description: Fields_1.Fields.mor_group_answers.crypto_procedure_for_disputes_description,
        },
        fieldPathsOnPayload: {
            crypto_procedure_for_disputes_description: 'mor_group_answers.crypto_procedure_for_disputes_description',
        },
        priority: 27,
    },
    {
        id: GroupId_1.GroupId.Crypto28,
        description: '',
        labelTitle: 'group.title.crypto_28',
        fallbackTitle: 'Cryptocurrency services',
        labelSubtitle: 'group.subtitle.crypto_28',
        fallbackSubtitle: '',
        fields: {
            crypto_high_risk_description: Fields_1.Fields.mor_group_answers.crypto_high_risk_description,
            crypto_is_high_risk: Fields_1.Fields.mor_group_answers.crypto_is_high_risk,
        },
        fieldPathsOnPayload: {
            crypto_high_risk_description: 'mor_group_answers.crypto_high_risk_description',
            crypto_is_high_risk: 'mor_group_answers.crypto_is_high_risk',
        },
        priority: 28,
    },
    {
        id: GroupId_1.GroupId.FinancialServices41,
        description: '',
        labelTitle: 'group.title.financial_services_41',
        fallbackTitle: 'Trading and other financial services',
        labelSubtitle: 'group.subtitle.financial_services_41',
        fallbackSubtitle: '',
        fields: {
            financial_service_percentage_merchants: Fields_1.Fields.mor_group_answers.financial_service_percentage_merchants,
            financial_service_risk_handling_description: Fields_1.Fields.mor_group_answers.financial_service_risk_handling_description,
            financial_service_transaction_volume: Fields_1.Fields.mor_group_answers.financial_service_transaction_volume,
            financial_service_year_of_experience: Fields_1.Fields.mor_group_answers.financial_service_year_of_experience,
        },
        fieldPathsOnPayload: {
            financial_service_percentage_merchants: 'mor_group_answers.financial_service_percentage_merchants',
            financial_service_risk_handling_description: 'mor_group_answers.financial_service_risk_handling_description',
            financial_service_transaction_volume: 'mor_group_answers.financial_service_transaction_volume',
            financial_service_year_of_experience: 'mor_group_answers.financial_service_year_of_experience',
        },
        priority: 41,
    },
    {
        id: GroupId_1.GroupId.FinancialServices42,
        description: '',
        labelTitle: 'group.title.financial_services_42',
        fallbackTitle: 'Trading and other financial services',
        labelSubtitle: 'group.subtitle.financial_services_42',
        fallbackSubtitle: '',
        fields: {
            financial_service_operation_not_allowed_description: Fields_1.Fields.mor_group_answers.financial_service_operation_not_allowed_description,
            financial_service_permission_description: Fields_1.Fields.mor_group_answers.financial_service_permission_description,
        },
        fieldPathsOnPayload: {
            financial_service_operation_not_allowed_description: 'mor_group_answers.financial_service_operation_not_allowed_description',
            financial_service_permission_description: 'mor_group_answers.financial_service_permission_description',
        },
        priority: 42,
    },
    {
        id: GroupId_1.GroupId.FinancialServices43,
        description: '',
        labelTitle: 'group.title.financial_services_43',
        fallbackTitle: 'Trading and other financial services',
        labelSubtitle: 'group.subtitle.financial_services_43',
        fallbackSubtitle: '',
        fields: {
            financial_service_due_diligence_key_criteria: Fields_1.Fields.mor_group_answers.financial_service_due_diligence_key_criteria,
            financial_service_due_diligence_key_criteria_other_description: Fields_1.Fields.mor_group_answers.financial_service_due_diligence_key_criteria_other_description,
        },
        fieldPathsOnPayload: {
            financial_service_due_diligence_key_criteria: 'mor_group_answers.financial_service_due_diligence_key_criteria',
            financial_service_due_diligence_key_criteria_other_description: 'mor_group_answers.financial_service_due_diligence_key_criteria_other_description',
        },
        priority: 43,
    },
    {
        id: GroupId_1.GroupId.FinancialServices44,
        description: '',
        labelTitle: 'group.title.financial_services_44',
        fallbackTitle: 'Trading and other financial services',
        labelSubtitle: 'group.subtitle.financial_services_44',
        fallbackSubtitle: '',
        fields: {
            financial_service_compliance_control: Fields_1.Fields.mor_group_answers.financial_service_compliance_control,
        },
        fieldPathsOnPayload: {
            financial_service_compliance_control: 'mor_group_answers.financial_service_compliance_control',
        },
        priority: 44,
    },
    {
        id: GroupId_1.GroupId.FinancialServices45,
        description: '',
        labelTitle: 'group.title.financial_services_45',
        fallbackTitle: 'Trading and other financial services',
        labelSubtitle: 'group.subtitle.financial_services_45',
        fallbackSubtitle: '',
        fields: {
            financial_service_company_conduct: Fields_1.Fields.mor_group_answers.financial_service_company_conduct,
        },
        fieldPathsOnPayload: {
            financial_service_company_conduct: 'mor_group_answers.financial_service_company_conduct',
        },
        priority: 45,
    },
    {
        id: GroupId_1.GroupId.FinancialServices46,
        description: '',
        labelTitle: 'group.title.financial_services_46',
        fallbackTitle: 'Trading and other financial services',
        labelSubtitle: 'group.subtitle.financial_services_46',
        fallbackSubtitle: '',
        fields: {
            financial_service_applicable_measures: Fields_1.Fields.mor_group_answers.financial_service_applicable_measures,
            financial_service_applicable_measures_other_description: Fields_1.Fields.mor_group_answers.financial_service_applicable_measures_other_description,
        },
        fieldPathsOnPayload: {
            financial_service_applicable_measures: 'mor_group_answers.financial_service_applicable_measures',
            financial_service_applicable_measures_other_description: 'mor_group_answers.financial_service_applicable_measures_other_description',
        },
        priority: 46,
    },
    {
        id: GroupId_1.GroupId.FinancialServices47,
        description: '',
        labelTitle: 'group.title.financial_services_47',
        fallbackTitle: 'Trading and other financial services',
        labelSubtitle: 'group.subtitle.financial_services_47',
        fallbackSubtitle: '',
        fields: {
            financial_service_procedure_for_disputes_description: Fields_1.Fields.mor_group_answers.financial_service_procedure_for_disputes_description,
        },
        fieldPathsOnPayload: {
            financial_service_procedure_for_disputes_description: 'mor_group_answers.financial_service_procedure_for_disputes_description',
        },
        priority: 47,
    },
    {
        id: GroupId_1.GroupId.FinancialServices48,
        description: '',
        labelTitle: 'group.title.financial_services_48',
        fallbackTitle: 'Trading and other financial services',
        labelSubtitle: 'group.subtitle.financial_services_48',
        fallbackSubtitle: '',
        fields: {
            financial_service_high_risk_description: Fields_1.Fields.mor_group_answers.financial_service_high_risk_description,
            financial_service_is_high_risk: Fields_1.Fields.mor_group_answers.financial_service_is_high_risk,
        },
        fieldPathsOnPayload: {
            financial_service_high_risk_description: 'mor_group_answers.financial_service_high_risk_description',
            financial_service_is_high_risk: 'mor_group_answers.financial_service_is_high_risk',
        },
        priority: 48,
    },
    {
        id: GroupId_1.GroupId.Gambling11,
        description: '',
        labelTitle: 'group.title.gambling_11',
        fallbackTitle: 'Gambling, Betting, Casinos',
        labelSubtitle: 'group.subtitle.gambling_11',
        fallbackSubtitle: '',
        fields: {
            gambling_percentage_merchants: Fields_1.Fields.mor_group_answers.gambling_percentage_merchants,
            gambling_risk_handling_description: Fields_1.Fields.mor_group_answers.gambling_risk_handling_description,
            gambling_transaction_volume: Fields_1.Fields.mor_group_answers.gambling_transaction_volume,
            gambling_year_of_experience: Fields_1.Fields.mor_group_answers.gambling_year_of_experience,
        },
        fieldPathsOnPayload: {
            gambling_percentage_merchants: 'mor_group_answers.gambling_percentage_merchants',
            gambling_risk_handling_description: 'mor_group_answers.gambling_risk_handling_description',
            gambling_transaction_volume: 'mor_group_answers.gambling_transaction_volume',
            gambling_year_of_experience: 'mor_group_answers.gambling_year_of_experience',
        },
        priority: 10,
    },
    {
        id: GroupId_1.GroupId.Gambling110,
        description: '',
        labelTitle: 'group.title.gambling_110',
        fallbackTitle: 'Gambling, Betting, Casinos',
        labelSubtitle: 'group.subtitle.gambling_110',
        fallbackSubtitle: '',
        fields: {
            gambling_high_risk_description: Fields_1.Fields.mor_group_answers.gambling_high_risk_description,
            gambling_is_high_risk: Fields_1.Fields.mor_group_answers.gambling_is_high_risk,
        },
        fieldPathsOnPayload: {
            gambling_high_risk_description: 'mor_group_answers.gambling_high_risk_description',
            gambling_is_high_risk: 'mor_group_answers.gambling_is_high_risk',
        },
        priority: 19,
    },
    {
        id: GroupId_1.GroupId.Gambling12,
        description: '',
        labelTitle: 'group.title.gambling_12',
        fallbackTitle: 'Gambling, Betting, Casinos',
        labelSubtitle: 'group.subtitle.gambling_12',
        fallbackSubtitle: '',
        fields: {
            gambling_operation_not_allowed_description: Fields_1.Fields.mor_group_answers.gambling_operation_not_allowed_description,
            gambling_permission_description: Fields_1.Fields.mor_group_answers.gambling_permission_description,
        },
        fieldPathsOnPayload: {
            gambling_operation_not_allowed_description: 'mor_group_answers.gambling_operation_not_allowed_description',
            gambling_permission_description: 'mor_group_answers.gambling_permission_description',
        },
        priority: 11,
    },
    {
        id: GroupId_1.GroupId.Gambling13,
        description: '',
        labelTitle: 'group.title.gambling_13',
        fallbackTitle: 'Gambling, Betting, Casinos',
        labelSubtitle: 'group.subtitle.gambling_13',
        fallbackSubtitle: '',
        fields: {
            gambling_due_diligence_key_criteria: Fields_1.Fields.mor_group_answers.gambling_due_diligence_key_criteria,
            gambling_due_diligence_key_criteria_other_description: Fields_1.Fields.mor_group_answers.gambling_due_diligence_key_criteria_other_description,
        },
        fieldPathsOnPayload: {
            gambling_due_diligence_key_criteria: 'mor_group_answers.gambling_due_diligence_key_criteria',
            gambling_due_diligence_key_criteria_other_description: 'mor_group_answers.gambling_due_diligence_key_criteria_other_description',
        },
        priority: 12,
    },
    {
        id: GroupId_1.GroupId.Gambling14,
        description: '',
        labelTitle: 'group.title.gambling_14',
        fallbackTitle: 'Gambling, Betting, Casinos',
        labelSubtitle: 'group.subtitle.gambling_14',
        fallbackSubtitle: '',
        fields: {
            gambling_compliance_control: Fields_1.Fields.mor_group_answers.gambling_compliance_control,
        },
        fieldPathsOnPayload: {
            gambling_compliance_control: 'mor_group_answers.gambling_compliance_control',
        },
        priority: 13,
    },
    {
        id: GroupId_1.GroupId.Gambling15,
        description: '',
        labelTitle: 'group.title.gambling_15',
        fallbackTitle: 'Gambling, Betting, Casinos',
        labelSubtitle: 'group.subtitle.gambling_15',
        fallbackSubtitle: '',
        fields: {
            gambling_company_conduct: Fields_1.Fields.mor_group_answers.gambling_company_conduct,
        },
        fieldPathsOnPayload: {
            gambling_company_conduct: 'mor_group_answers.gambling_company_conduct',
        },
        priority: 14,
    },
    {
        id: GroupId_1.GroupId.Gambling16,
        description: '',
        labelTitle: 'group.title.gambling_16',
        fallbackTitle: 'Gambling, Betting, Casinos',
        labelSubtitle: 'group.subtitle.gambling_16',
        fallbackSubtitle: '',
        fields: {
            gambling_applicable_measures: Fields_1.Fields.mor_group_answers.gambling_applicable_measures,
            gambling_applicable_measures_other_description: Fields_1.Fields.mor_group_answers.gambling_applicable_measures_other_description,
        },
        fieldPathsOnPayload: {
            gambling_applicable_measures: 'mor_group_answers.gambling_applicable_measures',
            gambling_applicable_measures_other_description: 'mor_group_answers.gambling_applicable_measures_other_description',
        },
        priority: 15,
    },
    {
        id: GroupId_1.GroupId.Gambling17,
        description: '',
        labelTitle: 'group.title.gambling_17',
        fallbackTitle: 'Gambling, Betting, Casinos',
        labelSubtitle: 'group.subtitle.gambling_17',
        fallbackSubtitle: '',
        fields: {
            gambling_procedure_for_disputes_description: Fields_1.Fields.mor_group_answers.gambling_procedure_for_disputes_description,
        },
        fieldPathsOnPayload: {
            gambling_procedure_for_disputes_description: 'mor_group_answers.gambling_procedure_for_disputes_description',
        },
        priority: 16,
    },
    {
        id: GroupId_1.GroupId.Gambling18,
        description: '',
        labelTitle: 'group.title.gambling_18',
        fallbackTitle: 'Gambling, Betting, Casinos',
        labelSubtitle: 'group.subtitle.gambling_18',
        fallbackSubtitle: '',
        fields: {
            gambling_risk_standards_description: Fields_1.Fields.mor_group_answers.gambling_risk_standards_description,
        },
        fieldPathsOnPayload: {
            gambling_risk_standards_description: 'mor_group_answers.gambling_risk_standards_description',
        },
        priority: 17,
    },
    {
        id: GroupId_1.GroupId.Gambling19,
        description: '',
        labelTitle: 'group.title.gambling_19',
        fallbackTitle: 'Gambling, Betting, Casinos',
        labelSubtitle: 'group.subtitle.gambling_19',
        fallbackSubtitle: '',
        fields: {
            gambling_customer_data_handling_description: Fields_1.Fields.mor_group_answers.gambling_customer_data_handling_description,
        },
        fieldPathsOnPayload: {
            gambling_customer_data_handling_description: 'mor_group_answers.gambling_customer_data_handling_description',
        },
        priority: 18,
    },
    {
        id: GroupId_1.GroupId.GroupConfirmation,
        description: '',
        labelTitle: 'group.title.group_confirmation',
        fallbackTitle: 'Group confirmation',
        labelSubtitle: 'group.subtitle.group_confirmation',
        fallbackSubtitle: '',
        fields: {
            group_confirmation: Fields_1.Fields.mor_group_answers.group_confirmation,
            group_confirmation_differences_description: Fields_1.Fields.mor_group_answers.group_confirmation_differences_description,
        },
        fieldPathsOnPayload: {
            group_confirmation: 'mor_group_answers.group_confirmation',
            group_confirmation_differences_description: 'mor_group_answers.group_confirmation_differences_description',
        },
        priority: 162,
    },
    {
        id: GroupId_1.GroupId.IllegalItemsProhibitedSegmentsControls1,
        description: '',
        labelTitle: 'group.title.illegal_items_prohibited_segments_controls_1',
        fallbackTitle: 'Prohibited and restricted segments',
        labelSubtitle: 'group.subtitle.illegal_items_prohibited_segments_controls_1',
        fallbackSubtitle: '',
        fields: {
            is_compliant_with_prohibited_lists: Fields_1.Fields.mor_group_answers.is_compliant_with_prohibited_lists,
        },
        fieldPathsOnPayload: {
            is_compliant_with_prohibited_lists: 'mor_group_answers.is_compliant_with_prohibited_lists',
        },
        priority: 150,
    },
    {
        id: GroupId_1.GroupId.IllegalItemsProhibitedSegmentsControls2,
        description: '',
        labelTitle: 'group.title.illegal_items_prohibited_segments_controls_2',
        fallbackTitle: 'Prohibited and restricted segments',
        labelSubtitle: 'group.subtitle.illegal_items_prohibited_segments_controls_2',
        fallbackSubtitle: '',
        fields: {
            has_prohibited_lists_review_process: Fields_1.Fields.mor_group_answers.has_prohibited_lists_review_process,
            no_prohibited_lists_review_process_description: Fields_1.Fields.mor_group_answers.no_prohibited_lists_review_process_description,
        },
        fieldPathsOnPayload: {
            has_prohibited_lists_review_process: 'mor_group_answers.has_prohibited_lists_review_process',
            no_prohibited_lists_review_process_description: 'mor_group_answers.no_prohibited_lists_review_process_description',
        },
        priority: 151,
    },
    {
        id: GroupId_1.GroupId.IllegalItemsProhibitedSegmentsControls3,
        description: '',
        labelTitle: 'group.title.illegal_items_prohibited_segments_controls_3',
        fallbackTitle: 'Prohibited and restricted segments',
        labelSubtitle: 'group.subtitle.illegal_items_prohibited_segments_controls_3',
        fallbackSubtitle: '',
        fields: {
            has_web_scraping_for_prohibited_lists: Fields_1.Fields.mor_group_answers.has_web_scraping_for_prohibited_lists,
            no_web_scraping_for_prohibited_lists_description: Fields_1.Fields.mor_group_answers.no_web_scraping_for_prohibited_lists_description,
            web_scraping_for_prohibited_lists_description: Fields_1.Fields.mor_group_answers.web_scraping_for_prohibited_lists_description,
        },
        fieldPathsOnPayload: {
            has_web_scraping_for_prohibited_lists: 'mor_group_answers.has_web_scraping_for_prohibited_lists',
            no_web_scraping_for_prohibited_lists_description: 'mor_group_answers.no_web_scraping_for_prohibited_lists_description',
            web_scraping_for_prohibited_lists_description: 'mor_group_answers.web_scraping_for_prohibited_lists_description',
        },
        priority: 152,
    },
    {
        id: GroupId_1.GroupId.InStoreGetStarted,
        description: 'Get started',
        labelTitle: 'group.title.in_store_get_started',
        fallbackTitle: 'Get your business started with Klarna.',
        labelSubtitle: 'group.subtitle.in_store_get_started',
        fallbackSubtitle: 'We need some basic information to get you to the right place',
        fields: {
            registration_country: Fields_1.Fields.business_information.registration_country,
        },
        fieldPathsOnPayload: {
            registration_country: 'business_information.registration_country',
        },
        priority: 10,
    },
    {
        id: GroupId_1.GroupId.InStoreLegalForm,
        description: 'Business legal entity details',
        labelTitle: 'group.title.in_store_legal_form',
        fallbackTitle: 'What type of business do you have?',
        labelSubtitle: 'group.subtitle.in_store_legal_form',
        fallbackSubtitle: 'We are required to ask some specific questions based on your business type.',
        fields: {
            legal_form: Fields_1.Fields.business_information.legal_form,
        },
        fieldPathsOnPayload: {
            legal_form: 'business_information.legal_form',
        },
        priority: 80,
    },
    {
        id: GroupId_1.GroupId.InStoreRegisteredAddress,
        description: 'In store address registered address.',
        labelTitle: 'group.title.in_store_registered_address',
        fallbackTitle: 'What are your registered address?',
        labelSubtitle: 'group.subtitle.in_store_registered_address',
        fallbackSubtitle: 'This is where your business is legally registered, and will appear in your klarna customer invoices.',
        fields: {
            company_name: Fields_1.Fields.business_information.company_name,
            registered_address: Fields_1.Fields.business_information.registered_address,
        },
        fieldPathsOnPayload: {
            company_name: 'business_information.company_name',
            registered_address: 'business_information.registered_address',
        },
        priority: 90,
    },
    {
        id: GroupId_1.GroupId.InStoreRegistration,
        description: 'Registration details',
        labelTitle: 'group.title.in_store_registration',
        fallbackTitle: 'Is your business a registered company?',
        labelSubtitle: 'group.subtitle.in_store_registration',
        fallbackSubtitle: 'We need your company registration number to verify your business details.',
        fields: {
            is_registered: Fields_1.Fields.business_information.is_registered,
            registration_authority: Fields_1.Fields.business_information.registration_authority,
            registration_id: Fields_1.Fields.business_information.registration_id,
        },
        fieldPathsOnPayload: {
            is_registered: 'business_information.is_registered',
            registration_authority: 'business_information.registration_authority',
            registration_id: 'business_information.registration_id',
        },
        priority: 60,
    },
    {
        id: GroupId_1.GroupId.InStoreStakeholder,
        description: 'In store owner.',
        labelTitle: 'group.title.in_store_stakeholder',
        fallbackTitle: 'Who manages the company?',
        labelSubtitle: 'group.subtitle.in_store_stakeholder',
        fallbackSubtitle: 'As financial institution, we are required to collect this information',
        fields: {
            persons: Fields_1.Fields.business_information.persons,
        },
        fieldPathsOnPayload: {
            persons: 'business_information.persons',
        },
        priority: 100,
    },
    {
        id: GroupId_1.GroupId.InStoreStores,
        description: 'Initial business information for in-store',
        labelTitle: 'group.title.in_store_stores',
        fallbackTitle: 'What are your store details?',
        labelSubtitle: 'group.subtitle.in_store_stores',
        fallbackSubtitle: 'We\'ll use the information to set up your account.',
        fields: {
            in_stores: Fields_1.Fields.in_stores,
        },
        fieldPathsOnPayload: {
            in_stores: 'in_stores',
        },
        priority: 30,
    },
    {
        id: GroupId_1.GroupId.InStoreVat,
        description: 'VAT registration details',
        labelTitle: 'group.title.in_store_vat',
        fallbackTitle: 'Is your business registered for VAT?',
        labelSubtitle: 'group.subtitle.in_store_vat',
        fallbackSubtitle: 'If you have a VAT number, we can more easily verify your company details.',
        fields: {
            subject_to_vat: Fields_1.Fields.business_information.subject_to_vat,
            vat_id: Fields_1.Fields.business_information.vat_id,
        },
        fieldPathsOnPayload: {
            subject_to_vat: 'business_information.subject_to_vat',
            vat_id: 'business_information.vat_id',
        },
        priority: 70,
    },
    {
        id: GroupId_1.GroupId.KeyPerformanceIndicator1,
        description: '',
        labelTitle: 'group.title.key_performance_indicator_1',
        fallbackTitle: 'Key Performance Indicators',
        labelSubtitle: 'group.subtitle.key_performance_indicator_1',
        fallbackSubtitle: '',
        fields: {
            has_kpi_for_aml_program: Fields_1.Fields.mor_group_answers.has_kpi_for_aml_program,
            no_kpi_for_aml_program_description: Fields_1.Fields.mor_group_answers.no_kpi_for_aml_program_description,
        },
        fieldPathsOnPayload: {
            has_kpi_for_aml_program: 'mor_group_answers.has_kpi_for_aml_program',
            no_kpi_for_aml_program_description: 'mor_group_answers.no_kpi_for_aml_program_description',
        },
        priority: 160,
    },
    {
        id: GroupId_1.GroupId.KeyPerformanceIndicator3,
        description: '',
        labelTitle: 'group.title.key_performance_indicator_3',
        fallbackTitle: 'Key Performance Indicators',
        labelSubtitle: 'group.subtitle.key_performance_indicator_3',
        fallbackSubtitle: '',
        fields: {
            kpi_for_aml_program: Fields_1.Fields.mor_group_answers.kpi_for_aml_program,
            kpi_for_aml_program_other_description: Fields_1.Fields.mor_group_answers.kpi_for_aml_program_other_description,
        },
        fieldPathsOnPayload: {
            kpi_for_aml_program: 'mor_group_answers.kpi_for_aml_program',
            kpi_for_aml_program_other_description: 'mor_group_answers.kpi_for_aml_program_other_description',
        },
        priority: 161,
    },
    {
        id: GroupId_1.GroupId.KycBearerShares,
        description: 'Bearer shares are a form of stock or ownership in a company where the person holding the physical share certificate is considered the owner, and ownership is usually not recorded',
        labelTitle: 'group.title.kyc_bearer_shares',
        fallbackTitle: 'KYC (Know Your Customer)',
        labelSubtitle: 'group.subtitle.kyc_bearer_shares',
        fallbackSubtitle: '',
        fields: {
            issue_bearer_shares: Fields_1.Fields.mor_business_information.issue_bearer_shares,
        },
        fieldPathsOnPayload: {
            issue_bearer_shares: 'mor_business_information.issue_bearer_shares',
        },
        priority: 3,
    },
    {
        id: GroupId_1.GroupId.KycGetStarted,
        description: '',
        labelTitle: 'group.title.kyc_get_started',
        fallbackTitle: 'KYC (Know Your Customer)',
        labelSubtitle: 'group.subtitle.kyc_get_started',
        fallbackSubtitle: 'What are your entity details for becoming Klarna\'s Acquiring Partner?',
        fields: {
            company_name: Fields_1.Fields.mor_business_information.company_name,
            legal_form: Fields_1.Fields.mor_business_information.legal_form,
            registered_address: Fields_1.Fields.mor_business_information.registered_address,
            registration_authority: Fields_1.Fields.mor_business_information.registration_authority,
            registration_id: Fields_1.Fields.mor_business_information.registration_id,
            vat_id: Fields_1.Fields.mor_business_information.vat_id,
            customer_service_email: Fields_1.Fields.mor_entity_answers.customer_service_email,
            customer_service_phone: Fields_1.Fields.mor_entity_answers.customer_service_phone,
            recipient_email: Fields_1.Fields.mor_entity_answers.recipient_email,
            store_url: Fields_1.Fields.mor_entity_answers.store_url,
        },
        fieldPathsOnPayload: {
            company_name: 'mor_business_information.company_name',
            legal_form: 'mor_business_information.legal_form',
            registered_address: 'mor_business_information.registered_address',
            registration_authority: 'mor_business_information.registration_authority',
            registration_id: 'mor_business_information.registration_id',
            vat_id: 'mor_business_information.vat_id',
            customer_service_email: 'mor_entity_answers.customer_service_email',
            customer_service_phone: 'mor_entity_answers.customer_service_phone',
            recipient_email: 'mor_entity_answers.recipient_email',
            store_url: 'mor_entity_answers.store_url',
        },
        priority: 1,
    },
    {
        id: GroupId_1.GroupId.KycNomineeShareholders,
        description: 'A nominee shareholder is an appointed representative entrusted to hold shares on behalf of another entity or individual. This arrangement is commonly utilized for confidentiality and privacy purposes while retaining control and ownership of the shares.',
        labelTitle: 'group.title.kyc_nominee_shareholders',
        fallbackTitle: 'KYC (Know Your Customer)',
        labelSubtitle: 'group.subtitle.kyc_nominee_shareholders',
        fallbackSubtitle: '',
        fields: {
            has_nominee_shareholders: Fields_1.Fields.mor_business_information.has_nominee_shareholders,
        },
        fieldPathsOnPayload: {
            has_nominee_shareholders: 'mor_business_information.has_nominee_shareholders',
        },
        priority: 4,
    },
    {
        id: GroupId_1.GroupId.KycPersons,
        description: 'Get started with KYC',
        labelTitle: 'group.title.kyc_persons',
        fallbackTitle: 'Who signs the contracts for your company?',
        labelSubtitle: 'group.subtitle.kyc_persons',
        fallbackSubtitle: 'Your business is about to conclude a contract with Klarna. We need to verify who is legally authorized to sign contracts.',
        fields: {
            persons: Fields_1.Fields.mor_business_information.persons,
        },
        fieldPathsOnPayload: {
            persons: 'mor_business_information.persons',
        },
        priority: 2,
    },
    {
        id: GroupId_1.GroupId.Licensing,
        description: 'A Partner Bank referred to above is a licensed financial institution that collaborates with an entity that provides financial services, that does not need to obtain a license or has not obtained one yet (subject to requirements in certain jurisdictions), allowing the latter to offer specific financial services or activities it could not perform independently due to regulatory constraints. Through this partnership, the Partner Bank uses its regulatory licenses and financial infrastructure to support the unlicensed entity.',
        labelTitle: 'group.title.licensing',
        fallbackTitle: 'Licensing',
        labelSubtitle: 'group.subtitle.licensing',
        fallbackSubtitle: '',
        fields: {
            legal_assessment: Fields_1.Fields.mor_entity_answers.legal_assessment,
            licensing: Fields_1.Fields.mor_entity_answers.licensing,
            regulators_website: Fields_1.Fields.mor_entity_answers.regulators_website,
        },
        fieldPathsOnPayload: {
            legal_assessment: 'mor_entity_answers.legal_assessment',
            licensing: 'mor_entity_answers.licensing',
            regulators_website: 'mor_entity_answers.regulators_website',
        },
        priority: 5,
    },
    {
        id: GroupId_1.GroupId.MandatoryConfirmation1,
        description: '',
        labelTitle: 'group.title.mandatory_confirmation_1',
        fallbackTitle: 'Group onboarding',
        labelSubtitle: 'group.subtitle.mandatory_confirmation_1',
        fallbackSubtitle: 'Please list all the entities to which this questionnaire applies providing their company registration number and their full legal name.',
        fields: {
            entities: Fields_1.Fields.mor_group_answers.entities,
        },
        fieldPathsOnPayload: {
            entities: 'mor_group_answers.entities',
        },
        priority: 2,
    },
    {
        id: GroupId_1.GroupId.MandatoryConfirmation2,
        description: '',
        labelTitle: 'group.title.mandatory_confirmation_2',
        fallbackTitle: 'Group onboarding',
        labelSubtitle: 'group.subtitle.mandatory_confirmation_2',
        fallbackSubtitle: 'Please confirm that all the following answers apply to all the entities mentioned in your application and that in case there are any differences, for example, due to regional regulations, this information will be provided to Klarna.',
        fields: {
            is_applicable_for_group_onboarding: Fields_1.Fields.mor_group_answers.is_applicable_for_group_onboarding,
        },
        fieldPathsOnPayload: {
            is_applicable_for_group_onboarding: 'mor_group_answers.is_applicable_for_group_onboarding',
        },
        priority: 3,
    },
    {
        id: GroupId_1.GroupId.Monitoring41,
        description: '',
        labelTitle: 'group.title.monitoring_41',
        fallbackTitle: 'Monitoring',
        labelSubtitle: 'group.subtitle.monitoring_41',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            has_transaction_monitoring: Fields_1.Fields.mor_group_answers.has_transaction_monitoring,
            no_transaction_monitoring_description: Fields_1.Fields.mor_group_answers.no_transaction_monitoring_description,
            transaction_monitoring_description: Fields_1.Fields.mor_group_answers.transaction_monitoring_description,
        },
        fieldPathsOnPayload: {
            has_transaction_monitoring: 'mor_group_answers.has_transaction_monitoring',
            no_transaction_monitoring_description: 'mor_group_answers.no_transaction_monitoring_description',
            transaction_monitoring_description: 'mor_group_answers.transaction_monitoring_description',
        },
        priority: 135,
    },
    {
        id: GroupId_1.GroupId.Monitoring42,
        description: '',
        labelTitle: 'group.title.monitoring_42',
        fallbackTitle: 'Monitoring',
        labelSubtitle: 'group.subtitle.monitoring_42',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            fraud_detection_description: Fields_1.Fields.mor_group_answers.fraud_detection_description,
            has_fraud_detection: Fields_1.Fields.mor_group_answers.has_fraud_detection,
            no_fraud_detection_description: Fields_1.Fields.mor_group_answers.no_fraud_detection_description,
        },
        fieldPathsOnPayload: {
            fraud_detection_description: 'mor_group_answers.fraud_detection_description',
            has_fraud_detection: 'mor_group_answers.has_fraud_detection',
            no_fraud_detection_description: 'mor_group_answers.no_fraud_detection_description',
        },
        priority: 137,
    },
    {
        id: GroupId_1.GroupId.Monitoring43,
        description: '',
        labelTitle: 'group.title.monitoring_43',
        fallbackTitle: 'Monitoring',
        labelSubtitle: 'group.subtitle.monitoring_43',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            disputed_and_fraud_analysis_description: Fields_1.Fields.mor_group_answers.disputed_and_fraud_analysis_description,
        },
        fieldPathsOnPayload: {
            disputed_and_fraud_analysis_description: 'mor_group_answers.disputed_and_fraud_analysis_description',
        },
        priority: 138,
    },
    {
        id: GroupId_1.GroupId.Monitoring44,
        description: '',
        labelTitle: 'group.title.monitoring_44',
        fallbackTitle: 'Monitoring',
        labelSubtitle: 'group.subtitle.monitoring_44',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            has_requirement_for_suspicious_activity_reporting: Fields_1.Fields.mor_group_answers.has_requirement_for_suspicious_activity_reporting,
            no_suspicious_activity_reporting_description: Fields_1.Fields.mor_group_answers.no_suspicious_activity_reporting_description,
            suspicious_activity_reporting_description: Fields_1.Fields.mor_group_answers.suspicious_activity_reporting_description,
        },
        fieldPathsOnPayload: {
            has_requirement_for_suspicious_activity_reporting: 'mor_group_answers.has_requirement_for_suspicious_activity_reporting',
            no_suspicious_activity_reporting_description: 'mor_group_answers.no_suspicious_activity_reporting_description',
            suspicious_activity_reporting_description: 'mor_group_answers.suspicious_activity_reporting_description',
        },
        priority: 139,
    },
    {
        id: GroupId_1.GroupId.NestedModel1,
        description: 'If your company has or plans to have business relationships with financial institutions (such as, but not limited to, payment service providers, money service businesses, points of sale, or payment facilitators) to distribute Klarna\'s services, please carefully read the following paragraph and complete the accompanying questionnaire. While the terminology might vary, Klarna\'s primary interest is in understanding if there are additional third parties (Distributors) you plan to engage with to distribute Klarna\'s products (similar to merchant of Record model), and whether these Distributors while distributing Klarna\'s products to their customers will undertake regulatory activities (AML & CTF), such as, for example, merchant underwriting (KYC), transaction monitoring, sanctions screening and other AML/KYC activities. This inquiry does not extend to outsourcing these activities to professional consulting companies providing AML & CTF services or entities within your corporate group that offer support; we are focused on those entities directly involved in the distribution of Klarna\'s products.',
        labelTitle: 'group.title.nested_model_1',
        fallbackTitle: 'Nested model',
        labelSubtitle: 'group.subtitle.nested_model_1',
        fallbackSubtitle: '',
        fields: {
            number_of_distributors_in_network: Fields_1.Fields.mor_group_answers.number_of_distributors_in_network,
        },
        fieldPathsOnPayload: {
            number_of_distributors_in_network: 'mor_group_answers.number_of_distributors_in_network',
        },
        priority: 57,
    },
    {
        id: GroupId_1.GroupId.NestedModel10,
        description: '',
        labelTitle: 'group.title.nested_model_10',
        fallbackTitle: 'Nested model',
        labelSubtitle: 'group.subtitle.nested_model_10',
        fallbackSubtitle: '',
        fields: {
            distributors_sub_merchants_risk_management: Fields_1.Fields.mor_group_answers.distributors_sub_merchants_risk_management,
        },
        fieldPathsOnPayload: {
            distributors_sub_merchants_risk_management: 'mor_group_answers.distributors_sub_merchants_risk_management',
        },
        priority: 66,
    },
    {
        id: GroupId_1.GroupId.NestedModel11,
        description: '',
        labelTitle: 'group.title.nested_model_11',
        fallbackTitle: 'Nested model',
        labelSubtitle: 'group.subtitle.nested_model_11',
        fallbackSubtitle: '',
        fields: {
            distributors_prohibited_lists_adherence_is_ensured: Fields_1.Fields.mor_group_answers.distributors_prohibited_lists_adherence_is_ensured,
        },
        fieldPathsOnPayload: {
            distributors_prohibited_lists_adherence_is_ensured: 'mor_group_answers.distributors_prohibited_lists_adherence_is_ensured',
        },
        priority: 67,
    },
    {
        id: GroupId_1.GroupId.NestedModel12,
        description: '',
        labelTitle: 'group.title.nested_model_12',
        fallbackTitle: 'Nested model',
        labelSubtitle: 'group.subtitle.nested_model_12',
        fallbackSubtitle: '',
        fields: {
            distributors_prohibited_lists_awareness_is_ensured: Fields_1.Fields.mor_group_answers.distributors_prohibited_lists_awareness_is_ensured,
        },
        fieldPathsOnPayload: {
            distributors_prohibited_lists_awareness_is_ensured: 'mor_group_answers.distributors_prohibited_lists_awareness_is_ensured',
        },
        priority: 67,
    },
    {
        id: GroupId_1.GroupId.NestedModel13,
        description: '',
        labelTitle: 'group.title.nested_model_13',
        fallbackTitle: 'Nested model',
        labelSubtitle: 'group.subtitle.nested_model_13',
        fallbackSubtitle: '',
        fields: {
            distributors_has_questionnaire: Fields_1.Fields.mor_group_answers.distributors_has_questionnaire,
        },
        fieldPathsOnPayload: {
            distributors_has_questionnaire: 'mor_group_answers.distributors_has_questionnaire',
        },
        priority: 67,
    },
    {
        id: GroupId_1.GroupId.NestedModel2,
        description: '',
        labelTitle: 'group.title.nested_model_2',
        fallbackTitle: 'Nested model',
        labelSubtitle: 'group.subtitle.nested_model_2',
        fallbackSubtitle: '',
        fields: {
            distributors_business_name: Fields_1.Fields.mor_group_answers.distributors_business_name,
        },
        fieldPathsOnPayload: {
            distributors_business_name: 'mor_group_answers.distributors_business_name',
        },
        priority: 58,
    },
    {
        id: GroupId_1.GroupId.NestedModel3,
        description: '',
        labelTitle: 'group.title.nested_model_3',
        fallbackTitle: 'Nested model',
        labelSubtitle: 'group.subtitle.nested_model_3',
        fallbackSubtitle: '',
        fields: {
            nested_model_signing_entity: Fields_1.Fields.mor_group_answers.nested_model_signing_entity,
            nested_model_signing_entity_other_description: Fields_1.Fields.mor_group_answers.nested_model_signing_entity_other_description,
        },
        fieldPathsOnPayload: {
            nested_model_signing_entity: 'mor_group_answers.nested_model_signing_entity',
            nested_model_signing_entity_other_description: 'mor_group_answers.nested_model_signing_entity_other_description',
        },
        priority: 59,
    },
    {
        id: GroupId_1.GroupId.NestedModel4,
        description: '',
        labelTitle: 'group.title.nested_model_4',
        fallbackTitle: 'Nested model',
        labelSubtitle: 'group.subtitle.nested_model_4',
        fallbackSubtitle: '',
        fields: {
            nested_model_payouts_processor: Fields_1.Fields.mor_group_answers.nested_model_payouts_processor,
            nested_model_payouts_processor_other_description: Fields_1.Fields.mor_group_answers.nested_model_payouts_processor_other_description,
        },
        fieldPathsOnPayload: {
            nested_model_payouts_processor: 'mor_group_answers.nested_model_payouts_processor',
            nested_model_payouts_processor_other_description: 'mor_group_answers.nested_model_payouts_processor_other_description',
        },
        priority: 60,
    },
    {
        id: GroupId_1.GroupId.NestedModel5,
        description: '',
        labelTitle: 'group.title.nested_model_5',
        fallbackTitle: 'Nested model',
        labelSubtitle: 'group.subtitle.nested_model_5',
        fallbackSubtitle: '',
        fields: {
            distributors_process_available: Fields_1.Fields.mor_group_answers.distributors_process_available,
            distributors_process_available_other_description: Fields_1.Fields.mor_group_answers.distributors_process_available_other_description,
        },
        fieldPathsOnPayload: {
            distributors_process_available: 'mor_group_answers.distributors_process_available',
            distributors_process_available_other_description: 'mor_group_answers.distributors_process_available_other_description',
        },
        priority: 61,
    },
    {
        id: GroupId_1.GroupId.NestedModel6,
        description: '',
        labelTitle: 'group.title.nested_model_6',
        fallbackTitle: 'Nested model',
        labelSubtitle: 'group.subtitle.nested_model_6',
        fallbackSubtitle: '',
        fields: {
            nature_of_relationship_difference: Fields_1.Fields.mor_group_answers.nature_of_relationship_difference,
        },
        fieldPathsOnPayload: {
            nature_of_relationship_difference: 'mor_group_answers.nature_of_relationship_difference',
        },
        priority: 62,
    },
    {
        id: GroupId_1.GroupId.NestedModel7,
        description: '',
        labelTitle: 'group.title.nested_model_7',
        fallbackTitle: 'Nested model',
        labelSubtitle: 'group.subtitle.nested_model_7',
        fallbackSubtitle: '',
        fields: {
            disputes_handling_by: Fields_1.Fields.mor_group_answers.disputes_handling_by,
        },
        fieldPathsOnPayload: {
            disputes_handling_by: 'mor_group_answers.disputes_handling_by',
        },
        priority: 63,
    },
    {
        id: GroupId_1.GroupId.NestedModel8,
        description: '',
        labelTitle: 'group.title.nested_model_8',
        fallbackTitle: 'Nested model',
        labelSubtitle: 'group.subtitle.nested_model_8',
        fallbackSubtitle: '',
        fields: {
            risk_handling_by: Fields_1.Fields.mor_group_answers.risk_handling_by,
        },
        fieldPathsOnPayload: {
            risk_handling_by: 'mor_group_answers.risk_handling_by',
        },
        priority: 64,
    },
    {
        id: GroupId_1.GroupId.NestedModel9,
        description: '',
        labelTitle: 'group.title.nested_model_9',
        fallbackTitle: 'Nested model',
        labelSubtitle: 'group.subtitle.nested_model_9',
        fallbackSubtitle: '',
        fields: {
            distributor_sanction_management: Fields_1.Fields.mor_group_answers.distributor_sanction_management,
        },
        fieldPathsOnPayload: {
            distributor_sanction_management: 'mor_group_answers.distributor_sanction_management',
        },
        priority: 65,
    },
    {
        id: GroupId_1.GroupId.OnboardingAndCustomerDueDiligence11,
        description: '',
        labelTitle: 'group.title.onboarding_and_customer_due_diligence_11',
        fallbackTitle: 'Onboarding and Ongoing Customer Due Diligence',
        labelSubtitle: 'group.subtitle.onboarding_and_customer_due_diligence_11',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            customer_due_diligence_conduct: Fields_1.Fields.mor_group_answers.customer_due_diligence_conduct,
        },
        fieldPathsOnPayload: {
            customer_due_diligence_conduct: 'mor_group_answers.customer_due_diligence_conduct',
        },
        priority: 68,
    },
    {
        id: GroupId_1.GroupId.OnboardingAndCustomerDueDiligence12,
        description: '',
        labelTitle: 'group.title.onboarding_and_customer_due_diligence_12',
        fallbackTitle: 'Onboarding and Ongoing Customer Due Diligence',
        labelSubtitle: 'group.subtitle.onboarding_and_customer_due_diligence_12',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            has_risk_classification: Fields_1.Fields.mor_group_answers.has_risk_classification,
            risk_classification_description: Fields_1.Fields.mor_group_answers.risk_classification_description,
        },
        fieldPathsOnPayload: {
            has_risk_classification: 'mor_group_answers.has_risk_classification',
            risk_classification_description: 'mor_group_answers.risk_classification_description',
        },
        priority: 69,
    },
    {
        id: GroupId_1.GroupId.OnboardingAndCustomerDueDiligence13,
        description: '',
        labelTitle: 'group.title.onboarding_and_customer_due_diligence_13',
        fallbackTitle: 'Onboarding and Ongoing Customer Due Diligence',
        labelSubtitle: 'group.subtitle.onboarding_and_customer_due_diligence_13',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            risk_factors_description: Fields_1.Fields.mor_group_answers.risk_factors_description,
            risk_factors_other_description: Fields_1.Fields.mor_group_answers.risk_factors_other_description,
        },
        fieldPathsOnPayload: {
            risk_factors_description: 'mor_group_answers.risk_factors_description',
            risk_factors_other_description: 'mor_group_answers.risk_factors_other_description',
        },
        priority: 70,
    },
    {
        id: GroupId_1.GroupId.OnboardingAndCustomerDueDiligence14,
        description: '',
        labelTitle: 'group.title.onboarding_and_customer_due_diligence_14',
        fallbackTitle: 'Onboarding and Ongoing Customer Due Diligence',
        labelSubtitle: 'group.subtitle.onboarding_and_customer_due_diligence_14',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            interval_is_risk_based: Fields_1.Fields.mor_group_answers.interval_is_risk_based,
            merchant_kyc_interval_description: Fields_1.Fields.mor_group_answers.merchant_kyc_interval_description,
            risk_model_description: Fields_1.Fields.mor_group_answers.risk_model_description,
        },
        fieldPathsOnPayload: {
            interval_is_risk_based: 'mor_group_answers.interval_is_risk_based',
            merchant_kyc_interval_description: 'mor_group_answers.merchant_kyc_interval_description',
            risk_model_description: 'mor_group_answers.risk_model_description',
        },
        priority: 71,
    },
    {
        id: GroupId_1.GroupId.OnboardingAndCustomerDueDiligence15,
        description: '',
        labelTitle: 'group.title.onboarding_and_customer_due_diligence_15',
        fallbackTitle: 'Onboarding and Ongoing Customer Due Diligence',
        labelSubtitle: 'group.subtitle.onboarding_and_customer_due_diligence_15',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            percentage_of_high_and_significant_high_risk: Fields_1.Fields.mor_group_answers.percentage_of_high_and_significant_high_risk,
        },
        fieldPathsOnPayload: {
            percentage_of_high_and_significant_high_risk: 'mor_group_answers.percentage_of_high_and_significant_high_risk',
        },
        priority: 73,
    },
    {
        id: GroupId_1.GroupId.OnboardingAndCustomerDueDiligence16,
        description: '',
        labelTitle: 'group.title.onboarding_and_customer_due_diligence_16',
        fallbackTitle: 'Onboarding and Ongoing Customer Due Diligence',
        labelSubtitle: 'group.subtitle.onboarding_and_customer_due_diligence_16',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            event_driven_reviews_description: Fields_1.Fields.mor_group_answers.event_driven_reviews_description,
            has_event_driven_reviews: Fields_1.Fields.mor_group_answers.has_event_driven_reviews,
        },
        fieldPathsOnPayload: {
            event_driven_reviews_description: 'mor_group_answers.event_driven_reviews_description',
            has_event_driven_reviews: 'mor_group_answers.has_event_driven_reviews',
        },
        priority: 74,
    },
    {
        id: GroupId_1.GroupId.OnboardingAndCustomerDueDiligence17,
        description: '',
        labelTitle: 'group.title.onboarding_and_customer_due_diligence_17',
        fallbackTitle: 'Onboarding and Ongoing Customer Due Diligence',
        labelSubtitle: 'group.subtitle.onboarding_and_customer_due_diligence_17',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            verify_collected_info: Fields_1.Fields.mor_group_answers.verify_collected_info,
            verify_collected_info_description: Fields_1.Fields.mor_group_answers.verify_collected_info_description,
        },
        fieldPathsOnPayload: {
            verify_collected_info: 'mor_group_answers.verify_collected_info',
            verify_collected_info_description: 'mor_group_answers.verify_collected_info_description',
        },
        priority: 75,
    },
    {
        id: GroupId_1.GroupId.OnboardingAndCustomerDueDiligence18,
        description: '',
        labelTitle: 'group.title.onboarding_and_customer_due_diligence_18',
        fallbackTitle: 'Onboarding and Ongoing Customer Due Diligence',
        labelSubtitle: 'group.subtitle.onboarding_and_customer_due_diligence_18',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            cdd_conducted_phase: Fields_1.Fields.mor_group_answers.cdd_conducted_phase,
            cdd_conducted_phase_other_description: Fields_1.Fields.mor_group_answers.cdd_conducted_phase_other_description,
        },
        fieldPathsOnPayload: {
            cdd_conducted_phase: 'mor_group_answers.cdd_conducted_phase',
            cdd_conducted_phase_other_description: 'mor_group_answers.cdd_conducted_phase_other_description',
        },
        priority: 76,
    },
    {
        id: GroupId_1.GroupId.OnboardingAndCustomerDueDiligence19,
        description: '',
        labelTitle: 'group.title.onboarding_and_customer_due_diligence_19',
        fallbackTitle: 'Onboarding and Ongoing Customer Due Diligence',
        labelSubtitle: 'group.subtitle.onboarding_and_customer_due_diligence_19',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            has_watch_list: Fields_1.Fields.mor_group_answers.has_watch_list,
        },
        fieldPathsOnPayload: {
            has_watch_list: 'mor_group_answers.has_watch_list',
        },
        priority: 77,
    },
    {
        id: GroupId_1.GroupId.OnboardingAndCustomerDueDiligence20,
        description: '',
        labelTitle: 'group.title.onboarding_and_customer_due_diligence_20',
        fallbackTitle: 'Onboarding and Ongoing Customer Due Diligence',
        labelSubtitle: 'group.subtitle.onboarding_and_customer_due_diligence_20',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            utilize_watch_list: Fields_1.Fields.mor_group_answers.utilize_watch_list,
            watch_list_solution_description: Fields_1.Fields.mor_group_answers.watch_list_solution_description,
        },
        fieldPathsOnPayload: {
            utilize_watch_list: 'mor_group_answers.utilize_watch_list',
            watch_list_solution_description: 'mor_group_answers.watch_list_solution_description',
        },
        priority: 78,
    },
    {
        id: GroupId_1.GroupId.OnboardingAndCustomerDueDiligence21,
        description: '',
        labelTitle: 'group.title.onboarding_and_customer_due_diligence_21',
        fallbackTitle: 'Onboarding and Ongoing Customer Due Diligence',
        labelSubtitle: 'group.subtitle.onboarding_and_customer_due_diligence_21',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            has_process_for_simplified_due_diligence: Fields_1.Fields.mor_group_answers.has_process_for_simplified_due_diligence,
            simplified_due_diligence_description: Fields_1.Fields.mor_group_answers.simplified_due_diligence_description,
        },
        fieldPathsOnPayload: {
            has_process_for_simplified_due_diligence: 'mor_group_answers.has_process_for_simplified_due_diligence',
            simplified_due_diligence_description: 'mor_group_answers.simplified_due_diligence_description',
        },
        priority: 79,
    },
    {
        id: GroupId_1.GroupId.OnboardingAndCustomerDueDiligence22,
        description: '',
        labelTitle: 'group.title.onboarding_and_customer_due_diligence_22',
        fallbackTitle: 'Onboarding and Ongoing Customer Due Diligence',
        labelSubtitle: 'group.subtitle.onboarding_and_customer_due_diligence_22',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            enhanced_due_diligence_description: Fields_1.Fields.mor_group_answers.enhanced_due_diligence_description,
            has_process_for_enhanced_due_diligence: Fields_1.Fields.mor_group_answers.has_process_for_enhanced_due_diligence,
            safety_measures_description: Fields_1.Fields.mor_group_answers.safety_measures_description,
        },
        fieldPathsOnPayload: {
            enhanced_due_diligence_description: 'mor_group_answers.enhanced_due_diligence_description',
            has_process_for_enhanced_due_diligence: 'mor_group_answers.has_process_for_enhanced_due_diligence',
            safety_measures_description: 'mor_group_answers.safety_measures_description',
        },
        priority: 80,
    },
    {
        id: GroupId_1.GroupId.OnboardingAndCustomerDueDiligence23,
        description: '',
        labelTitle: 'group.title.onboarding_and_customer_due_diligence_23',
        fallbackTitle: 'Onboarding and Ongoing Customer Due Diligence',
        labelSubtitle: 'group.subtitle.onboarding_and_customer_due_diligence_23',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            edd_measures: Fields_1.Fields.mor_group_answers.edd_measures,
            edd_measures_other_description: Fields_1.Fields.mor_group_answers.edd_measures_other_description,
        },
        fieldPathsOnPayload: {
            edd_measures: 'mor_group_answers.edd_measures',
            edd_measures_other_description: 'mor_group_answers.edd_measures_other_description',
        },
        priority: 81,
    },
    {
        id: GroupId_1.GroupId.PartnerBank,
        description: 'If you plan to become Klarna\'s Merchant of Record and you are a financial service provider operating without your own financial license, but you have established a partnership with a financial institution and operate under their licensing, kindly read the definition below and complete the questionnaire. Definition: A Partner Bank referred to below is a licensed financial institution that collaborates with an entity that provides financial services, that does not need to obtain a license or has not obtained one yet (subject to requirements in certain jurisdictions), allowing the latter to offer specific financial services or activities it couldn\'t independently due to regulatory constraints. Through this partnership, the Partner Bank uses its regulatory licenses and financial infrastructure to support the entity, facilitating its engagement in financial activities within a compliant framework. While the terminology can vary, including terms like bank partnership agreement, partnership banking agreement, or sponsor bank, the essence remains the same: a setup where the entity leverages a bank\'s license and support to conduct financial operations.',
        labelTitle: 'group.title.partner_bank',
        fallbackTitle: 'Partner Bank questionnaire',
        labelSubtitle: 'group.subtitle.partner_bank',
        fallbackSubtitle: 'Please provide the full legal entity name and registered address of your Partner Bank',
        fields: {
            partner_bank_address: Fields_1.Fields.mor_entity_answers.partner_bank_address,
            partner_bank_name: Fields_1.Fields.mor_entity_answers.partner_bank_name,
        },
        fieldPathsOnPayload: {
            partner_bank_address: 'mor_entity_answers.partner_bank_address',
            partner_bank_name: 'mor_entity_answers.partner_bank_name',
        },
        priority: 6,
    },
    {
        id: GroupId_1.GroupId.PartnerBankChangeNotification,
        description: '',
        labelTitle: 'group.title.partner_bank_change_notification',
        fallbackTitle: 'Partner Bank questionnaire',
        labelSubtitle: 'group.subtitle.partner_bank_change_notification',
        fallbackSubtitle: '',
        fields: {
            notify_klarna: Fields_1.Fields.mor_entity_answers.notify_klarna,
        },
        fieldPathsOnPayload: {
            notify_klarna: 'mor_entity_answers.notify_klarna',
        },
        priority: 10,
    },
    {
        id: GroupId_1.GroupId.PartnerBankCollaborationDetails,
        description: '',
        labelTitle: 'group.title.partner_bank_collaboration_details',
        fallbackTitle: 'Partner Bank questionnaire',
        labelSubtitle: 'group.subtitle.partner_bank_collaboration_details',
        fallbackSubtitle: '',
        fields: {
            collaboration_details: Fields_1.Fields.mor_entity_answers.collaboration_details,
        },
        fieldPathsOnPayload: {
            collaboration_details: 'mor_entity_answers.collaboration_details',
        },
        priority: 11,
    },
    {
        id: GroupId_1.GroupId.PartnerBankContractEntity,
        description: '',
        labelTitle: 'group.title.partner_bank_contract_entity',
        fallbackTitle: 'Partner Bank questionnaire',
        labelSubtitle: 'group.subtitle.partner_bank_contract_entity',
        fallbackSubtitle: '',
        fields: {
            merchant_contract_entity: Fields_1.Fields.mor_entity_answers.merchant_contract_entity,
            other_merchant_contract_entity_detail: Fields_1.Fields.mor_entity_answers.other_merchant_contract_entity_detail,
        },
        fieldPathsOnPayload: {
            merchant_contract_entity: 'mor_entity_answers.merchant_contract_entity',
            other_merchant_contract_entity_detail: 'mor_entity_answers.other_merchant_contract_entity_detail',
        },
        priority: 12,
    },
    {
        id: GroupId_1.GroupId.PartnerBankFinancialLicense,
        description: '',
        labelTitle: 'group.title.partner_bank_financial_license',
        fallbackTitle: 'Partner Bank questionnaire',
        labelSubtitle: 'group.subtitle.partner_bank_financial_license',
        fallbackSubtitle: '',
        fields: {
            partner_bank_has_financial_license_details: Fields_1.Fields.mor_entity_answers.partner_bank_has_financial_license_details,
        },
        fieldPathsOnPayload: {
            partner_bank_has_financial_license_details: 'mor_entity_answers.partner_bank_has_financial_license_details',
        },
        priority: 7,
    },
    {
        id: GroupId_1.GroupId.PartnerBankFinancialLicenseObtain,
        description: '',
        labelTitle: 'group.title.partner_bank_financial_license_obtain',
        fallbackTitle: 'Partner Bank questionnaire',
        labelSubtitle: 'group.subtitle.partner_bank_financial_license_obtain',
        fallbackSubtitle: '',
        fields: {
            obtain_financial_license: Fields_1.Fields.mor_entity_answers.obtain_financial_license,
            obtain_financial_license_details: Fields_1.Fields.mor_entity_answers.obtain_financial_license_details,
        },
        fieldPathsOnPayload: {
            obtain_financial_license: 'mor_entity_answers.obtain_financial_license',
            obtain_financial_license_details: 'mor_entity_answers.obtain_financial_license_details',
        },
        priority: 8,
    },
    {
        id: GroupId_1.GroupId.PartnerBankPayouts,
        description: '',
        labelTitle: 'group.title.partner_bank_payouts',
        fallbackTitle: 'Partner Bank questionnaire',
        labelSubtitle: 'group.subtitle.partner_bank_payouts',
        fallbackSubtitle: '',
        fields: {
            other_payouts_processing_entity_detail: Fields_1.Fields.mor_entity_answers.other_payouts_processing_entity_detail,
            payouts_processing_entity: Fields_1.Fields.mor_entity_answers.payouts_processing_entity,
        },
        fieldPathsOnPayload: {
            other_payouts_processing_entity_detail: 'mor_entity_answers.other_payouts_processing_entity_detail',
            payouts_processing_entity: 'mor_entity_answers.payouts_processing_entity',
        },
        priority: 13,
    },
    {
        id: GroupId_1.GroupId.PartnerBankSanctionsCompliance,
        description: '',
        labelTitle: 'group.title.partner_bank_sanctions_compliance',
        fallbackTitle: 'Partner Bank questionnaire',
        labelSubtitle: 'group.subtitle.partner_bank_sanctions_compliance',
        fallbackSubtitle: 'Please specify which aspects of the AML & CTF and sanctions programs are managed by your organization, and which are handled by the Partner Bank. Please also elaborate on reporting responsibilities (suspicious activity or transaction, sanction transaction or activities that breach sanctions regulations) among your company and your Partner Bank.',
        fields: {
            sanctions_compliance_program_details: Fields_1.Fields.mor_entity_answers.sanctions_compliance_program_details,
        },
        fieldPathsOnPayload: {
            sanctions_compliance_program_details: 'mor_entity_answers.sanctions_compliance_program_details',
        },
        priority: 14,
    },
    {
        id: GroupId_1.GroupId.PartnerBankSwitch,
        description: '',
        labelTitle: 'group.title.partner_bank_switch',
        fallbackTitle: 'Partner Bank questionnaire',
        labelSubtitle: 'group.subtitle.partner_bank_switch',
        fallbackSubtitle: '',
        fields: {
            switch_partner_bank: Fields_1.Fields.mor_entity_answers.switch_partner_bank,
            switch_partner_bank_details: Fields_1.Fields.mor_entity_answers.switch_partner_bank_details,
        },
        fieldPathsOnPayload: {
            switch_partner_bank: 'mor_entity_answers.switch_partner_bank',
            switch_partner_bank_details: 'mor_entity_answers.switch_partner_bank_details',
        },
        priority: 9,
    },
    {
        id: GroupId_1.GroupId.PoliticallyExposedPersonsAdverseMediaScreening21,
        description: '',
        labelTitle: 'group.title.politically_exposed_persons_adverse_media_screening_21',
        fallbackTitle: 'Politically Exposed Persons and Adverse Media Screening',
        labelSubtitle: 'group.subtitle.politically_exposed_persons_adverse_media_screening_21',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            has_pep_screening: Fields_1.Fields.mor_group_answers.has_pep_screening,
            pep_screening_description: Fields_1.Fields.mor_group_answers.pep_screening_description,
        },
        fieldPathsOnPayload: {
            has_pep_screening: 'mor_group_answers.has_pep_screening',
            pep_screening_description: 'mor_group_answers.pep_screening_description',
        },
        priority: 90,
    },
    {
        id: GroupId_1.GroupId.PoliticallyExposedPersonsAdverseMediaScreening22,
        description: '',
        labelTitle: 'group.title.politically_exposed_persons_adverse_media_screening_22',
        fallbackTitle: 'Politically Exposed Persons and Adverse Media Screening',
        labelSubtitle: 'group.subtitle.politically_exposed_persons_adverse_media_screening_22',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            pep_screening_roles: Fields_1.Fields.mor_group_answers.pep_screening_roles,
            pep_screening_roles_other_description: Fields_1.Fields.mor_group_answers.pep_screening_roles_other_description,
        },
        fieldPathsOnPayload: {
            pep_screening_roles: 'mor_group_answers.pep_screening_roles',
            pep_screening_roles_other_description: 'mor_group_answers.pep_screening_roles_other_description',
        },
        priority: 91,
    },
    {
        id: GroupId_1.GroupId.PoliticallyExposedPersonsAdverseMediaScreening23,
        description: '',
        labelTitle: 'group.title.politically_exposed_persons_adverse_media_screening_23',
        fallbackTitle: 'Politically Exposed Persons and Adverse Media Screening',
        labelSubtitle: 'group.subtitle.politically_exposed_persons_adverse_media_screening_23',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            pep_screening_frequency: Fields_1.Fields.mor_group_answers.pep_screening_frequency,
            pep_screening_frequency_other_description: Fields_1.Fields.mor_group_answers.pep_screening_frequency_other_description,
        },
        fieldPathsOnPayload: {
            pep_screening_frequency: 'mor_group_answers.pep_screening_frequency',
            pep_screening_frequency_other_description: 'mor_group_answers.pep_screening_frequency_other_description',
        },
        priority: 92,
    },
    {
        id: GroupId_1.GroupId.PoliticallyExposedPersonsAdverseMediaScreening24,
        description: '',
        labelTitle: 'group.title.politically_exposed_persons_adverse_media_screening_24',
        fallbackTitle: 'Politically Exposed Persons and Adverse Media Screening',
        labelSubtitle: 'group.subtitle.politically_exposed_persons_adverse_media_screening_24',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            approval_process_description: Fields_1.Fields.mor_group_answers.approval_process_description,
        },
        fieldPathsOnPayload: {
            approval_process_description: 'mor_group_answers.approval_process_description',
        },
        priority: 93,
    },
    {
        id: GroupId_1.GroupId.PoliticallyExposedPersonsAdverseMediaScreening25,
        description: '',
        labelTitle: 'group.title.politically_exposed_persons_adverse_media_screening_25',
        fallbackTitle: 'Politically Exposed Persons and Adverse Media Screening',
        labelSubtitle: 'group.subtitle.politically_exposed_persons_adverse_media_screening_25',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            adverse_media_screening_alternative_processes: Fields_1.Fields.mor_group_answers.adverse_media_screening_alternative_processes,
            adverse_media_screening_description: Fields_1.Fields.mor_group_answers.adverse_media_screening_description,
            has_adverse_media_screening: Fields_1.Fields.mor_group_answers.has_adverse_media_screening,
        },
        fieldPathsOnPayload: {
            adverse_media_screening_alternative_processes: 'mor_group_answers.adverse_media_screening_alternative_processes',
            adverse_media_screening_description: 'mor_group_answers.adverse_media_screening_description',
            has_adverse_media_screening: 'mor_group_answers.has_adverse_media_screening',
        },
        priority: 94,
    },
    {
        id: GroupId_1.GroupId.ProductChannel,
        description: 'Details about how sales are done',
        labelTitle: 'group.title.product_channel',
        fallbackTitle: 'How do you plan to do your sales?',
        labelSubtitle: 'group.subtitle.product_channel',
        fallbackSubtitle: 'We will use this information to set up your account.',
        fields: {
            product_channel: Fields_1.Fields.business_information.product_channel,
            should_auto_capture_orders: Fields_1.Fields.business_information.should_auto_capture_orders,
        },
        fieldPathsOnPayload: {
            product_channel: 'business_information.product_channel',
            should_auto_capture_orders: 'business_information.should_auto_capture_orders',
        },
        priority: 20,
    },
    {
        id: GroupId_1.GroupId.ProgramDetailsAndGovernance1,
        description: '',
        labelTitle: 'group.title.program_details_and_governance_1',
        fallbackTitle: 'AML & CTF and Sanctions framework and governance',
        labelSubtitle: 'group.subtitle.program_details_and_governance_1',
        fallbackSubtitle: '',
        fields: {
            aml_ctf_laws_regulations: Fields_1.Fields.mor_group_answers.aml_ctf_laws_regulations,
        },
        fieldPathsOnPayload: {
            aml_ctf_laws_regulations: 'mor_group_answers.aml_ctf_laws_regulations',
        },
        priority: 49,
    },
    {
        id: GroupId_1.GroupId.ProgramDetailsAndGovernance2,
        description: '',
        labelTitle: 'group.title.program_details_and_governance_2',
        fallbackTitle: 'AML & CTF and Sanctions framework and governance',
        labelSubtitle: 'group.subtitle.program_details_and_governance_2',
        fallbackSubtitle: '',
        fields: {
            policy_areas: Fields_1.Fields.mor_group_answers.policy_areas,
            policy_areas_other_description: Fields_1.Fields.mor_group_answers.policy_areas_other_description,
        },
        fieldPathsOnPayload: {
            policy_areas: 'mor_group_answers.policy_areas',
            policy_areas_other_description: 'mor_group_answers.policy_areas_other_description',
        },
        priority: 50,
    },
    {
        id: GroupId_1.GroupId.ProgramDetailsAndGovernance3,
        description: '',
        labelTitle: 'group.title.program_details_and_governance_3',
        fallbackTitle: 'AML & CTF and Sanctions framework and governance',
        labelSubtitle: 'group.subtitle.program_details_and_governance_3',
        fallbackSubtitle: '',
        fields: {
            policies_and_programs_approval_function: Fields_1.Fields.mor_group_answers.policies_and_programs_approval_function,
        },
        fieldPathsOnPayload: {
            policies_and_programs_approval_function: 'mor_group_answers.policies_and_programs_approval_function',
        },
        priority: 51,
    },
    {
        id: GroupId_1.GroupId.ProgramDetailsAndGovernance4,
        description: '',
        labelTitle: 'group.title.program_details_and_governance_4',
        fallbackTitle: 'AML & CTF and Sanctions framework and governance',
        labelSubtitle: 'group.subtitle.program_details_and_governance_4',
        fallbackSubtitle: '',
        fields: {
            aml_ctf_functions: Fields_1.Fields.mor_group_answers.aml_ctf_functions,
            aml_ctf_functions_other_description: Fields_1.Fields.mor_group_answers.aml_ctf_functions_other_description,
        },
        fieldPathsOnPayload: {
            aml_ctf_functions: 'mor_group_answers.aml_ctf_functions',
            aml_ctf_functions_other_description: 'mor_group_answers.aml_ctf_functions_other_description',
        },
        priority: 52,
    },
    {
        id: GroupId_1.GroupId.ProgramDetailsAndGovernance5,
        description: 'Independent testing for AML (Anti-Money Laundering) refers to a process where an impartial and objective entity, typically separate from the operational and compliance functions, potentially an external company, evaluates the effectiveness of an institution\'s AML program. This evaluation involves conducting comprehensive reviews and assessments of the institution\'s policies, procedures, systems, and controls to ensure compliance with regulatory requirements and industry best practices in detecting and preventing money laundering and terrorist financing activities.',
        labelTitle: 'group.title.program_details_and_governance_5',
        fallbackTitle: 'AML & CTF and Sanctions framework and governance',
        labelSubtitle: 'group.subtitle.program_details_and_governance_5',
        fallbackSubtitle: '',
        fields: {
            has_independent_testing_mechanism: Fields_1.Fields.mor_group_answers.has_independent_testing_mechanism,
        },
        fieldPathsOnPayload: {
            has_independent_testing_mechanism: 'mor_group_answers.has_independent_testing_mechanism',
        },
        priority: 53,
    },
    {
        id: GroupId_1.GroupId.ProgramDetailsAndGovernance6,
        description: '',
        labelTitle: 'group.title.program_details_and_governance_6',
        fallbackTitle: 'AML & CTF and Sanctions framework and governance',
        labelSubtitle: 'group.subtitle.program_details_and_governance_6',
        fallbackSubtitle: '',
        fields: {
            has_aml_ctf_findings: Fields_1.Fields.mor_group_answers.has_aml_ctf_findings,
            has_aml_ctf_findings_description: Fields_1.Fields.mor_group_answers.has_aml_ctf_findings_description,
        },
        fieldPathsOnPayload: {
            has_aml_ctf_findings: 'mor_group_answers.has_aml_ctf_findings',
            has_aml_ctf_findings_description: 'mor_group_answers.has_aml_ctf_findings_description',
        },
        priority: 54,
    },
    {
        id: GroupId_1.GroupId.ProgramDetailsAndGovernance7,
        description: '',
        labelTitle: 'group.title.program_details_and_governance_7',
        fallbackTitle: 'AML & CTF and Sanctions framework and governance',
        labelSubtitle: 'group.subtitle.program_details_and_governance_7',
        fallbackSubtitle: '',
        fields: {
            cdd_kyc_backlog_description: Fields_1.Fields.mor_group_answers.cdd_kyc_backlog_description,
            has_cdd_kyc_backlog: Fields_1.Fields.mor_group_answers.has_cdd_kyc_backlog,
        },
        fieldPathsOnPayload: {
            cdd_kyc_backlog_description: 'mor_group_answers.cdd_kyc_backlog_description',
            has_cdd_kyc_backlog: 'mor_group_answers.has_cdd_kyc_backlog',
        },
        priority: 55,
    },
    {
        id: GroupId_1.GroupId.ProgramDetailsAndGovernance8,
        description: 'We are interested in understanding whether your company works with or plans to work with financial institutions, such as payment service providers, money service businesses, or payment facilitators, to support distribution of Klarna\'s services. These companies may not only  help to distribute Klarna\'s products, but also  take on important regulatory responsibilities, such as verifying merchant identities (KYC), monitoring transactions, conducting sanctions screenings and other  to comply with Anti-Money Laundering (AML), Counter-Terrorism Financing (CTF) and Sanctions laws and regulations. Klarna is interested in understanding if such partners are part of your distribution model, focusing specifically on those directly handling the distribution and compliance activities related to Klarna\'s products, rather than those simply providing outsourced support or consulting services.',
        labelTitle: 'group.title.program_details_and_governance_8',
        fallbackTitle: 'AML & CTF and Sanctions framework and governance',
        labelSubtitle: 'group.subtitle.program_details_and_governance_8',
        fallbackSubtitle: '',
        fields: {
            entrust_other_contracted_entities: Fields_1.Fields.mor_group_answers.entrust_other_contracted_entities,
        },
        fieldPathsOnPayload: {
            entrust_other_contracted_entities: 'mor_group_answers.entrust_other_contracted_entities',
        },
        priority: 56,
    },
    {
        id: GroupId_1.GroupId.SanctionsControls310,
        description: '',
        labelTitle: 'group.title.sanctions_controls_310',
        fallbackTitle: 'Sanctions controls',
        labelSubtitle: 'group.subtitle.sanctions_controls_310',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            sanction_true_hits_handling: Fields_1.Fields.mor_group_answers.sanction_true_hits_handling,
            sanction_true_hits_handling_other_description: Fields_1.Fields.mor_group_answers.sanction_true_hits_handling_other_description,
        },
        fieldPathsOnPayload: {
            sanction_true_hits_handling: 'mor_group_answers.sanction_true_hits_handling',
            sanction_true_hits_handling_other_description: 'mor_group_answers.sanction_true_hits_handling_other_description',
        },
        priority: 122,
    },
    {
        id: GroupId_1.GroupId.SanctionsControls3111,
        description: '',
        labelTitle: 'group.title.sanctions_controls_311_1',
        fallbackTitle: 'Sanctions controls',
        labelSubtitle: 'group.subtitle.sanctions_controls_311_1',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            will_operate_in_us: Fields_1.Fields.mor_group_answers.will_operate_in_us,
        },
        fieldPathsOnPayload: {
            will_operate_in_us: 'mor_group_answers.will_operate_in_us',
        },
        priority: 123,
    },
    {
        id: GroupId_1.GroupId.SanctionsControls3112,
        description: '',
        labelTitle: 'group.title.sanctions_controls_311_2',
        fallbackTitle: 'Sanctions controls',
        labelSubtitle: 'group.subtitle.sanctions_controls_311_2',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            has_us_transaction_sanction_screening: Fields_1.Fields.mor_group_answers.has_us_transaction_sanction_screening,
            no_us_transaction_sanction_screening_description: Fields_1.Fields.mor_group_answers.no_us_transaction_sanction_screening_description,
        },
        fieldPathsOnPayload: {
            has_us_transaction_sanction_screening: 'mor_group_answers.has_us_transaction_sanction_screening',
            no_us_transaction_sanction_screening_description: 'mor_group_answers.no_us_transaction_sanction_screening_description',
        },
        priority: 124,
    },
    {
        id: GroupId_1.GroupId.SanctionsControls311,
        description: '',
        labelTitle: 'group.title.sanctions_controls_31_1',
        fallbackTitle: 'Sanctions controls',
        labelSubtitle: 'group.subtitle.sanctions_controls_31_1',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            sanction_lists: Fields_1.Fields.mor_group_answers.sanction_lists,
            specific_lists_not_marked_description: Fields_1.Fields.mor_group_answers.specific_lists_not_marked_description,
        },
        fieldPathsOnPayload: {
            sanction_lists: 'mor_group_answers.sanction_lists',
            specific_lists_not_marked_description: 'mor_group_answers.specific_lists_not_marked_description',
        },
        priority: 110,
    },
    {
        id: GroupId_1.GroupId.SanctionsControls312,
        description: '',
        labelTitle: 'group.title.sanctions_controls_31_2',
        fallbackTitle: 'Sanctions controls',
        labelSubtitle: 'group.subtitle.sanctions_controls_31_2',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            sanction_lists_other_description: Fields_1.Fields.mor_group_answers.sanction_lists_other_description,
        },
        fieldPathsOnPayload: {
            sanction_lists_other_description: 'mor_group_answers.sanction_lists_other_description',
        },
        priority: 111,
    },
    {
        id: GroupId_1.GroupId.SanctionsControls313,
        description: '',
        labelTitle: 'group.title.sanctions_controls_31_3',
        fallbackTitle: 'Sanctions controls',
        labelSubtitle: 'group.subtitle.sanctions_controls_31_3',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            additional_lists_not_marked_description: Fields_1.Fields.mor_group_answers.additional_lists_not_marked_description,
        },
        fieldPathsOnPayload: {
            additional_lists_not_marked_description: 'mor_group_answers.additional_lists_not_marked_description',
        },
        priority: 112,
    },
    {
        id: GroupId_1.GroupId.SanctionsControls32,
        description: '',
        labelTitle: 'group.title.sanctions_controls_32',
        fallbackTitle: 'Sanctions controls',
        labelSubtitle: 'group.subtitle.sanctions_controls_32',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            sanction_screening_roles: Fields_1.Fields.mor_group_answers.sanction_screening_roles,
            sanction_screening_roles_other_description: Fields_1.Fields.mor_group_answers.sanction_screening_roles_other_description,
        },
        fieldPathsOnPayload: {
            sanction_screening_roles: 'mor_group_answers.sanction_screening_roles',
            sanction_screening_roles_other_description: 'mor_group_answers.sanction_screening_roles_other_description',
        },
        priority: 113,
    },
    {
        id: GroupId_1.GroupId.SanctionsControls33,
        description: '',
        labelTitle: 'group.title.sanctions_controls_33',
        fallbackTitle: 'Sanctions controls',
        labelSubtitle: 'group.subtitle.sanctions_controls_33',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            has_live_sanction_screening: Fields_1.Fields.mor_group_answers.has_live_sanction_screening,
            live_sanction_screening_description: Fields_1.Fields.mor_group_answers.live_sanction_screening_description,
        },
        fieldPathsOnPayload: {
            has_live_sanction_screening: 'mor_group_answers.has_live_sanction_screening',
            live_sanction_screening_description: 'mor_group_answers.live_sanction_screening_description',
        },
        priority: 114,
    },
    {
        id: GroupId_1.GroupId.SanctionsControls341,
        description: '',
        labelTitle: 'group.title.sanctions_controls_34_1',
        fallbackTitle: 'Sanctions controls',
        labelSubtitle: 'group.subtitle.sanctions_controls_34_1',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            sanction_screening_performer: Fields_1.Fields.mor_group_answers.sanction_screening_performer,
            sanction_screening_performer_external_description: Fields_1.Fields.mor_group_answers.sanction_screening_performer_external_description,
        },
        fieldPathsOnPayload: {
            sanction_screening_performer: 'mor_group_answers.sanction_screening_performer',
            sanction_screening_performer_external_description: 'mor_group_answers.sanction_screening_performer_external_description',
        },
        priority: 115,
    },
    {
        id: GroupId_1.GroupId.SanctionsControls35,
        description: '',
        labelTitle: 'group.title.sanctions_controls_35',
        fallbackTitle: 'Sanctions controls',
        labelSubtitle: 'group.subtitle.sanctions_controls_35',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            has_transaction_sanction_screening: Fields_1.Fields.mor_group_answers.has_transaction_sanction_screening,
            no_transaction_sanction_screening_description: Fields_1.Fields.mor_group_answers.no_transaction_sanction_screening_description,
        },
        fieldPathsOnPayload: {
            has_transaction_sanction_screening: 'mor_group_answers.has_transaction_sanction_screening',
            no_transaction_sanction_screening_description: 'mor_group_answers.no_transaction_sanction_screening_description',
        },
        priority: 117,
    },
    {
        id: GroupId_1.GroupId.SanctionsControls36,
        description: '',
        labelTitle: 'group.title.sanctions_controls_36',
        fallbackTitle: 'Sanctions controls',
        labelSubtitle: 'group.subtitle.sanctions_controls_36',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            has_live_transaction_sanction_screening: Fields_1.Fields.mor_group_answers.has_live_transaction_sanction_screening,
            no_live_transaction_sanction_screening_description: Fields_1.Fields.mor_group_answers.no_live_transaction_sanction_screening_description,
        },
        fieldPathsOnPayload: {
            has_live_transaction_sanction_screening: 'mor_group_answers.has_live_transaction_sanction_screening',
            no_live_transaction_sanction_screening_description: 'mor_group_answers.no_live_transaction_sanction_screening_description',
        },
        priority: 118,
    },
    {
        id: GroupId_1.GroupId.SanctionsControls37,
        description: '',
        labelTitle: 'group.title.sanctions_controls_37',
        fallbackTitle: 'Sanctions controls',
        labelSubtitle: 'group.subtitle.sanctions_controls_37',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            transaction_sanction_screening_elements: Fields_1.Fields.mor_group_answers.transaction_sanction_screening_elements,
            transaction_sanction_screening_elements_other_description: Fields_1.Fields.mor_group_answers.transaction_sanction_screening_elements_other_description,
        },
        fieldPathsOnPayload: {
            transaction_sanction_screening_elements: 'mor_group_answers.transaction_sanction_screening_elements',
            transaction_sanction_screening_elements_other_description: 'mor_group_answers.transaction_sanction_screening_elements_other_description',
        },
        priority: 119,
    },
    {
        id: GroupId_1.GroupId.SanctionsControls38,
        description: '',
        labelTitle: 'group.title.sanctions_controls_38',
        fallbackTitle: 'Sanctions controls',
        labelSubtitle: 'group.subtitle.sanctions_controls_38',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            geographic_sanction_screening: Fields_1.Fields.mor_group_answers.geographic_sanction_screening,
            geographic_sanction_screening_other_description: Fields_1.Fields.mor_group_answers.geographic_sanction_screening_other_description,
        },
        fieldPathsOnPayload: {
            geographic_sanction_screening: 'mor_group_answers.geographic_sanction_screening',
            geographic_sanction_screening_other_description: 'mor_group_answers.geographic_sanction_screening_other_description',
        },
        priority: 120,
    },
    {
        id: GroupId_1.GroupId.SanctionsControls39,
        description: '',
        labelTitle: 'group.title.sanctions_controls_39',
        fallbackTitle: 'Sanctions controls',
        labelSubtitle: 'group.subtitle.sanctions_controls_39',
        fallbackSubtitle: 'AML & CTF and Sanctions processes',
        fields: {
            has_sectoral_sanctions_control: Fields_1.Fields.mor_group_answers.has_sectoral_sanctions_control,
            sectoral_sanctions_control_description: Fields_1.Fields.mor_group_answers.sectoral_sanctions_control_description,
        },
        fieldPathsOnPayload: {
            has_sectoral_sanctions_control: 'mor_group_answers.has_sectoral_sanctions_control',
            sectoral_sanctions_control_description: 'mor_group_answers.sectoral_sanctions_control_description',
        },
        priority: 121,
    },
    {
        id: GroupId_1.GroupId.SensitiveGoods,
        description: 'Sensitive goods',
        labelTitle: 'group.title.sensitive_goods',
        fallbackTitle: 'Do you offer any of the following products or services at your physical store?',
        labelSubtitle: 'group.subtitle.sensitive_goods',
        fallbackSubtitle: 'Klarna might define some items as restricted based on market, laws, sales volume, risk appetite, and other limitations that can be allowed and shall not be processed without Klarna\'s approval.',
        fields: {
            sensitive_goods: Fields_1.Fields.sensitive_goods,
        },
        fieldPathsOnPayload: {
            sensitive_goods: 'sensitive_goods',
        },
        priority: 50,
    },
    {
        id: GroupId_1.GroupId.SubMerchantPortfolioInfo1,
        description: '',
        labelTitle: 'group.title.sub_merchant_portfolio_info_1',
        fallbackTitle: 'Portfolio',
        labelSubtitle: 'group.subtitle.sub_merchant_portfolio_info_1',
        fallbackSubtitle: 'Please list the top five countries the consumers of your merchants are located in (max. 5).',
        fields: {
            top_consumer_countries: Fields_1.Fields.mor_group_answers.top_consumer_countries,
        },
        fieldPathsOnPayload: {
            top_consumer_countries: 'mor_group_answers.top_consumer_countries',
        },
        priority: 4,
    },
    {
        id: GroupId_1.GroupId.SubMerchantPortfolioInfo2,
        description: '',
        labelTitle: 'group.title.sub_merchant_portfolio_info_2',
        fallbackTitle: 'Portfolio',
        labelSubtitle: 'group.subtitle.sub_merchant_portfolio_info_2',
        fallbackSubtitle: 'Please identify the top five jurisdictions where the majority of your merchants are incorporated (max. 5).',
        fields: {
            top_merchant_countries: Fields_1.Fields.mor_group_answers.top_merchant_countries,
        },
        fieldPathsOnPayload: {
            top_merchant_countries: 'mor_group_answers.top_merchant_countries',
        },
        priority: 5,
    },
    {
        id: GroupId_1.GroupId.SubMerchantPortfolioInfo3,
        description: '',
        labelTitle: 'group.title.sub_merchant_portfolio_info_3',
        fallbackTitle: 'Portfolio',
        labelSubtitle: 'group.subtitle.sub_merchant_portfolio_info_3',
        fallbackSubtitle: '',
        fields: {
            number_of_merchant_onboard_next_twelve_months: Fields_1.Fields.mor_group_answers.number_of_merchant_onboard_next_twelve_months,
        },
        fieldPathsOnPayload: {
            number_of_merchant_onboard_next_twelve_months: 'mor_group_answers.number_of_merchant_onboard_next_twelve_months',
        },
        priority: 6,
    },
    {
        id: GroupId_1.GroupId.SubMerchantPortfolioInfo4,
        description: '',
        labelTitle: 'group.title.sub_merchant_portfolio_info_4',
        fallbackTitle: 'Portfolio',
        labelSubtitle: 'group.subtitle.sub_merchant_portfolio_info_4',
        fallbackSubtitle: '',
        fields: {
            dropshipping_volume_percentage: Fields_1.Fields.mor_group_answers.dropshipping_volume_percentage,
        },
        fieldPathsOnPayload: {
            dropshipping_volume_percentage: 'mor_group_answers.dropshipping_volume_percentage',
        },
        priority: 7,
    },
    {
        id: GroupId_1.GroupId.SubMerchantPortfolioInfo5,
        description: '',
        labelTitle: 'group.title.sub_merchant_portfolio_info_5',
        fallbackTitle: 'Portfolio',
        labelSubtitle: 'group.subtitle.sub_merchant_portfolio_info_5',
        fallbackSubtitle: 'How many percent (%) of the volume will be distributed by merchants?',
        fields: {
            in_store_merchant_volume_percentage: Fields_1.Fields.mor_group_answers.in_store_merchant_volume_percentage,
            online_merchant_volume_percentage: Fields_1.Fields.mor_group_answers.online_merchant_volume_percentage,
        },
        fieldPathsOnPayload: {
            in_store_merchant_volume_percentage: 'mor_group_answers.in_store_merchant_volume_percentage',
            online_merchant_volume_percentage: 'mor_group_answers.online_merchant_volume_percentage',
        },
        priority: 8,
    },
    {
        id: GroupId_1.GroupId.SubMerchantPortfolioInfo6AdultServices,
        description: 'Adult services, such as digital adult services and erotic content for online viewing, refer to internet-based platforms or websites that provide sexual content, for example videos, images, and live streams, and any other similar content or services intended for adult audiences - the list is not exhaustive, as these services may encompass a range of other related offerings. Examples of MCCs are (the list is not exhaustive) 7273, 5967',
        labelTitle: 'group.title.sub_merchant_portfolio_info_6_adult_services',
        fallbackTitle: 'Portfolio',
        labelSubtitle: 'group.subtitle.sub_merchant_portfolio_info_6_adult_services',
        fallbackSubtitle: 'Adult / erotic services (excluding physical merchandise or products, only applies to digital adult and erotic content for online viewing)',
        fields: {
            has_adult_service_segment: Fields_1.Fields.mor_group_answers.has_adult_service_segment,
        },
        fieldPathsOnPayload: {
            has_adult_service_segment: 'mor_group_answers.has_adult_service_segment',
        },
        priority: 30,
    },
    {
        id: GroupId_1.GroupId.SubMerchantPortfolioInfo6Crypto,
        description: 'Cryptocurrency services refer to platforms and businesses that facilitate, for example, the use, trading, and management of digital currencies such as Bitcoin, Ethereum, and similar tokens. These services may include cryptocurrency exchanges, wallets, payment processors, and mining operations - this list is not exhaustive, as the cryptocurrency industry encompasses a wide range of activities and services. Examples of MCCs are (the list is not exhaustive) 6051',
        labelTitle: 'group.title.sub_merchant_portfolio_info_6_crypto',
        fallbackTitle: 'Portfolio',
        labelSubtitle: 'group.subtitle.sub_merchant_portfolio_info_6_crypto',
        fallbackSubtitle: 'Cryptocurrency services',
        fields: {
            has_crypto_segment: Fields_1.Fields.mor_group_answers.has_crypto_segment,
        },
        fieldPathsOnPayload: {
            has_crypto_segment: 'mor_group_answers.has_crypto_segment',
        },
        priority: 20,
    },
    {
        id: GroupId_1.GroupId.SubMerchantPortfolioInfo6FinancialServices,
        description: 'Trading and other financial services encompass platforms and businesses that provide activities such as stock trading, forex trading, investment management, and financial advisory services. Examples include brokerage firms, money service businesses, w-wallets, trading platforms, asset management companies, and financial planners - this list is not comprehensive, as the financial services industry includes a wide variety of other related activities and offerings. Examples of MCCs are (the list is not exhaustive) 4829, 6010, 6011, 6012, 6050, 6211, 6529, 6530, 6531, 6532, 6533, 6534, 6535, 6540, 7778, 6536, 6537, 6538, 6539, 6540, 7276',
        labelTitle: 'group.title.sub_merchant_portfolio_info_6_financial_services',
        fallbackTitle: 'Portfolio',
        labelSubtitle: 'group.subtitle.sub_merchant_portfolio_info_6_financial_services',
        fallbackSubtitle: 'Trading (excluding cryptocurrency trading, including Forex trading and Financial asset trading) and other financial services (Money Service Business, E-wallets, Money Transfer, Currency Exchange, Mobile Payments)',
        fields: {
            has_financial_services_segment: Fields_1.Fields.mor_group_answers.has_financial_services_segment,
        },
        fieldPathsOnPayload: {
            has_financial_services_segment: 'mor_group_answers.has_financial_services_segment',
        },
        priority: 40,
    },
    {
        id: GroupId_1.GroupId.SubMerchantPortfolioInfo6Gambling,
        description: 'Gambling, betting, and casinos refer to internet-based platforms where users can participate in, for example, games of chance or skill, place bets on various events (like sports or horse races), and play casino games such as poker, slots, and roulette and other of the similar nature - the list is not exhaustive as these platforms may include a variety of other related activities. Examples of MCCs (the list is not exhaustive) are 7995, 7800, 7801, 7802',
        labelTitle: 'group.title.sub_merchant_portfolio_info_6_gambling',
        fallbackTitle: 'Portfolio',
        labelSubtitle: 'group.subtitle.sub_merchant_portfolio_info_6_gambling',
        fallbackSubtitle: 'Gambling, betting, casinos',
        fields: {
            has_gambling_segment: Fields_1.Fields.mor_group_answers.has_gambling_segment,
        },
        fieldPathsOnPayload: {
            has_gambling_segment: 'mor_group_answers.has_gambling_segment',
        },
        priority: 9,
    },
    {
        id: GroupId_1.GroupId.UpsellStores,
        description: 'Information about stores',
        labelTitle: 'group.title.upsell_stores',
        fallbackTitle: 'What are your store details?',
        labelSubtitle: 'group.subtitle.upsell_stores',
        fallbackSubtitle: 'We\'ll use the information to set up your account.',
        fields: {
            upsell_stores: Fields_1.Fields.upsell_stores,
        },
        fieldPathsOnPayload: {
            upsell_stores: 'upsell_stores',
        },
        priority: 30,
    },
];
exports.groups = groups;
